<template>
  <div class="edit-experiencia" v-if="experiencia">
    <div class="header">
      <div class="container container--flex-nav">
        <button
          class="edit-zona__btn edit-zona__btn--nav"
          @click="navigateFromExperiencia"
        >
          <i class="fas fa-arrow-alt-circle-left"></i>Ir a destino
        </button>
        <div class="buttons">
          <div class="edit-zona__loading-button">
            <button
              v-if="id"
              type="button"
              class="edit-zona__btn edit-zona__btn--warning"
              @click="deleteRequest({ id, destinoId })"
              :disabled="isLoading"
            >
              Eliminar experiencia
            </button>
            
            <button
              v-if="id"
              type="button"
              class="edit-zona__btn"
              :class="isOculto ? 'edit-zona__btn--success' : 'edit-zona__btn--secondary'"
              style="margin-right: 12px;"
              @click="toggleOcultoRequest"
              :disabled="isLoading"
              :title="isOculto ? 'Esta experiencia esta oculta del listado publico. Click para mostrarla nuevamente.' : 'Ocultar temporalmente: no aparecera en el listado publico pero la URL directa seguira funcionando.'"
            >
              <i class="fas" :class="isOculto ? 'fa-eye' : 'fa-eye-slash'" style="margin-right:6px;"></i>
              {{ isOculto ? 'Mostrar en listado' : 'Ocultar temporalmente' }}
            </button>
            <button
              v-if="id"
              type="button"
              class="edit-zona__btn edit-zona__btn--info"
              style="margin-right: 12px;"
              @click="duplicarComoVersionCaja"
              :disabled="isLoading || duplicandoVersion"
              title="Crea una versión (otra duración/contenido) de esta escapada para usar dentro de cajas de regalo. Pre-poblada; edítala en ~2 min."
            >
              <i class="fas fa-gift" style="margin-right:6px;"></i>
              {{ duplicandoVersion ? 'Creando…' : 'Duplicar como versión de caja' }}
            </button>
            <button
              v-if="id"
              type="button"
              class="edit-zona__btn edit-zona__btn--secondary"
              @click="toggleVersionesCaja"
            >
              {{ mostrarVersionesCaja ? 'Ocultar versiones' : 'Ver versiones de caja' }}
            </button>
            <div v-if="isLoading" class="lds-dual-ring"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="id && mostrarVersionesCaja" style="max-width: 900px; margin: 0 auto 20px; padding: 16px; border: 1px solid #e5e5e5; border-radius: 10px; background: #fafafa;">
      <strong>Versiones de caja de esta escapada ({{ versionesCaja.length }})</strong>
      <p style="font-size: 13px; color: #777; margin: 4px 0 10px;">
        Alternativas creadas desde esta escapada para usar dentro de cajas de regalo.
      </p>
      <p v-if="versionesCajaCargadas && !versionesCaja.length" style="color:#999;">Aún no hay versiones. Usa “Duplicar como versión de caja”.</p>
      <ul style="list-style:none; padding:0; margin:0;">
        <li v-for="v in versionesCaja" :key="v.id" style="display:flex; align-items:center; justify-content:space-between; padding:8px 0; border-bottom:1px solid #eee;">
          <span>
            {{ v.nombre || '(sin nombre)' }}
            <small style="color:#999;">· {{ v.noches }} noches · {{ (v.cajaSlugs || []).length }} caja(s) · {{ v.publicada ? 'publicada' : 'borrador' }}</small>
          </span>
          <button type="button" class="edit-zona__btn edit-zona__btn--info" style="padding:4px 12px;" @click="editarVersionCaja(v.id)">Editar</button>
        </li>
      </ul>
    </div>
    <h1 class="heading heading--1 heading--center">
      Gestion de experiencia
    </h1>
    <h3 v-if="experiencia.titulo" class="heading heading--1 heading--center">
      {{ experiencia.titulo }}
    </h3>
    <form
      class="edit-experiencia__form-container"
      @submit.prevent="
        id
          ? submitRequest({ action: 'update', zonaId, destinoId, id })
          : submitRequest({ action: 'create', zonaId, destinoId })
      "
    >
      <div
        class="edit-experiencia__informacion edit-experiencia__informacion--1"
      >
        <h3 class="heading heading--3 heading--center">
          Informacion principal
        </h3>
        <div
          class="edit-experiencia__container edit-experiencia__container--flex"
        >
          <div class="edit-experiencia__side edit-experiencia__side--left">
            <!-- Informacion principal | titulo -->
            <div class="edit-zona__input-group">
              <I18nField
                label="Titulo"
                type="text"
                :value-es="experiencia.titulo"
                :value-en="experiencia.ingles.titulo"
                :value-pt="experiencia.portugues && experiencia.portugues.titulo"
                :manual-override="experiencia.manualOverride && experiencia.manualOverride.titulo"
                @change="(lang, val) => onI18nFieldChange('titulo', lang, val, 'text')"
              />
            </div>

            <!-- Informacion principal | titulo de destino -->
            <div class="edit-zona__input-group">
              <I18nField
                label="Titulo de destino"
                type="text"
                :value-es="experiencia.tituloDestino"
                :value-en="experiencia.ingles.tituloDestino"
                :value-pt="experiencia.portugues && experiencia.portugues.tituloDestino"
                :manual-override="experiencia.manualOverride && experiencia.manualOverride.tituloDestino"
                @change="(lang, val) => onI18nFieldChange('tituloDestino', lang, val, 'text')"
              />
            </div>

            <div class="edit-zona__input-group">
              <I18nField
                label="Resumen principal"
                type="textarea"
                :rows="10"
                :value-es="experiencia.resumen"
                :value-en="experiencia.ingles.resumen"
                :value-pt="experiencia.portugues && experiencia.portugues.resumen"
                :manual-override="experiencia.manualOverride && experiencia.manualOverride.resumen"
                @change="(lang, val) => onI18nFieldChange('resumen', lang, val, 'text')"
              />
            </div>

            <hr>

            <h3 class="heading heading--3 heading--center mt-4">Configuración SEO</h3>
            <div class="edit-zona__input-group">
              <I18nField
                label="Titulo:"
                type="text"
                :value-es="experiencia.seo_titulo"
                :value-en="experiencia.ingles.seo_titulo"
                :value-pt="experiencia.portugues && experiencia.portugues.seo_titulo"
                :manual-override="experiencia.manualOverride && experiencia.manualOverride.seo_titulo"
                @change="(lang, val) => onI18nFieldChange('seo_titulo', lang, val, 'text')"
              />
            </div>
            <div class="edit-zona__input-group">
              <label class="edit-zona__label">Slug</label>
              <input
                class="edit-zona__input"
                type="text"
                name="slug"
                id="slug"
                :value="experiencia.slug"
                @input="handleChange">
            </div>
            <div class="edit-zona__input-group">
              <I18nField
                label="Etiquetas"
                type="array-strings"
                placeholder="Agregar etiqueta"
                :value-es="experiencia.tags"
                :value-en="experiencia.ingles.tags"
                :value-pt="experiencia.portugues && experiencia.portugues.tags"
                :manual-override="experiencia.manualOverride && experiencia.manualOverride.tags"
                @add-item="(lang, item) => onI18nAddItem('tags', lang, item)"
                @remove-item="(lang, index) => onI18nRemoveItem('tags', lang, index)"
              />
            </div>
            <!-- Etiquetas (lista borrador, pendientes de guardar) -->
            <table
              v-if="(experiencia.experienciaBorrador.tags && experiencia.experienciaBorrador.tags.length > 0)
                || (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.tags && experiencia.ingles.experienciaBorrador.tags.length > 0)
                || (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.tags && experiencia.portugues.experienciaBorrador.tags.length > 0)"
              class="table table-striped"
            >
              <thead style="background-color: #fff;">
                <tr>
                  <th scope="col">Etiqueta por agregar</th>
                  <th scope="col">Idioma</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody style="background-color: #fff;">
                <tr v-for="(tag, index) in experiencia.experienciaBorrador.tags" :key="`tag-borrador-es-${index}`">
                  <td>{{ tag }}</td>
                  <td>ES</td>
                  <td>
                    <button
                      class="btn btn-danger btn-sm"
                      @click="borrarItem({ borrador: true, name: 'tags', index, language: 'es' })"
                    >
                      X
                    </button>
                  </td>
                </tr>
                <tr v-for="(tag, index) in (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.tags) || []" :key="`tag-borrador-en-${index}`">
                  <td>{{ tag }}</td>
                  <td>EN</td>
                  <td>
                    <button
                      class="btn btn-danger btn-sm"
                      @click="borrarItem({ borrador: true, name: 'tags', index, language: 'en' })"
                    >
                      X
                    </button>
                  </td>
                </tr>
                <tr v-for="(tag, index) in (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.tags) || []" :key="`tag-borrador-pt-${index}`">
                  <td>{{ tag }}</td>
                  <td>PT</td>
                  <td>
                    <button
                      class="btn btn-danger btn-sm"
                      @click="borrarItem({ borrador: true, name: 'tags', index, language: 'pt' })"
                    >
                      X
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="edit-experiencia__side edit-experiencia__side--right"
          >
            <div class="edit-zona__input-group">
              <!-- Informacion principal | Imagen de slideshow -->
              <label class="edit-experiencia__label"
                >Imagen de previsualizacion</label
              >

              <input
                type="file"
                name="carousel-img"
                accept="image/*"
                @change="
                  addImg({
                    event: $event,
                    type: 'carousel',
                    level: 'experiencia',
                  })
                "
              />

              <a
                href
                v-if="
                  experiencia.carouselImgUrl || zonaImgsToSave.carouselImgUrl
                "
                @click.prevent="
                  experiencia.carouselImgUrl
                    ? deleteImg({
                        type: 'carousel',
                        level: 'experiencias',
                        url: experiencia.carouselImgUrl,
                        id: id,
                      })
                    : deleteUnsavedImg({ type: 'carousel' })
                "
                class="edit-experiencia__img-link"
              >
                <img
                  :src="
                    experiencia.carouselImgUrl
                      ? experiencia.carouselImgUrl
                      : zonaImgsToSave.carouselImgUrl
                  "
                  alt="heading-img"
                  class="edit-experiencia__img"
                />
              </a>
            </div>

            <div class="edit-zona__input-group">
              <!-- Informacion principal | imagenes de hero -->
              <label class="edit-experiencia__label"
                >Imagenes para el hero</label
              >
              <input
                type="file"
                accept="image/*, .mp4"
                name="hero-imgs"
                @change="addHeroImg($event)"
              />

              <div class="edit-experiencia__img-container">
                <a
                  href
                  class="edit-experiencia__img-container"
                  v-for="(item, index) in getHeroContentBorrador"
                  :key="index"
                  @click.prevent="deleteUnsavedImg({ type: 'hero', index })"
                >
                  <template v-if="item.type === 'image'">
                    <img
                      :src="item.contentUrl"
                      alt="hero-images"
                      class="edit-experiencia__img"
                    />
                  </template>
                  <template v-else>
                    <video
                      autoplay
                      muted
                      loop
                      class="edit-experiencia__img edit-experiencia__img--1"
                    >
                      <source :src="item.contentUrl" />
                    </video>
                  </template>
                </a>
              </div>

              <div class="edit-experiencia__img-container">
                <a
                  href
                  class="edit-experiencia__img-container"
                  v-for="(item, index) in getHeroContent"
                  :key="index"
                  @click.prevent="
                    deleteImg({
                      type: 'hero',
                      level: 'experiencias',
                      url: item.contentUrl,
                      id: id,
                    })
                  "
                >
                  <template v-if="item.type !== 'mp4'">
                    <img
                      :src="item.contentUrl"
                      alt="hero-images"
                      class="edit-experiencia__img"
                    />
                  </template>
                  <template v-else>
                    <video
                      autoplay
                      muted
                      loop
                      class="edit-experiencia__img edit-experiencia__img--1"
                    >
                      <source :src="item.contentUrl" />
                    </video>
                  </template>
                </a>
              </div>
            </div>

            <!-- Galeria mixta foto+video (Brief Bunny Fase 1, 18 may 2026). -->
            <!-- Coexiste con la seccion "Imagenes para el hero" legacy: el -->
            <!-- front publico va a mostrar `medios[]` cuando este poblado y -->
            <!-- cae a `heroImgUrls[]` legacy cuando no. Pablo migra una -->
            <!-- experiencia a la vez. -->
            <div class="edit-zona__input-group">
              <label class="edit-experiencia__label">
                Galeria mixta (fotos + videos verticales)
              </label>
              <EditorMediosGaleria
                :value="experiencia.medios || []"
                :zona-id="zonaId"
                :destino-id="destinoId"
                :experiencia-id="id"
                @input="onMediosChange"
              />
            </div>

            <!-- Informacion principal | Contenido de youtube -->
            <div class="edit-experiencia__informacion-importante">
              <h5 class="heading heading--5">Contenido de Youtube</h5>
              <div
                class="edit-zona__container--fluid"
                v-if="experiencia.youtubeMedia.length > 0"
              >
                <ul class="edit-zona__list edit-zona__list--1">
                  <li
                    class="edit-zona__list-item"
                    v-for="(item, index) in experiencia.youtubeMedia"
                    :key="index"
                  >
                    <div class="edit-zona__list-content">
                      <div class="edit-zona__container--fluid">
                        <iframe
                          class="edit-zona__youtube-iframe"
                          :src="item"
                          frameborder="0"
                        ></iframe>
                      </div>
                      <div class="edit-zona__buttons edit-zona__buttons--right">
                        <button
                          type="button"
                          @click="
                            borrarItem({
                              borrador: false,
                              name: 'youtubeMedia',
                              index,
                            })
                          "
                          class="
                            edit-zona__btn
                            edit-zona__btn--warning
                            edit-zona__btn--consejos
                          "
                        >
                          Eliminar
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <!-- Gestion de informacion importante | items de la seccion youtubeMedia agregados al borrador -->
              <div
                class="edit-zona__container--fluid"
                v-if="experiencia.experienciaBorrador.youtubeMedia.length > 0"
              >
                <label class="edit-experiencia__label"
                  >Contenido por agregar</label
                >

                <ul class="edit-zona__list edit-zona__list--1">
                  <li
                    class="edit-zona__list-item"
                    v-for="(item, index) in experiencia.experienciaBorrador
                      .youtubeMedia"
                    :key="index"
                  >
                    <div class="edit-zona__list-content">
                      <a :href="item">Ir al video</a>
                      <div class="edit-zona__container">
                        <iframe
                          class="edit-zona__youtube-iframe"
                          :src="item"
                          frameborder="0"
                        ></iframe>
                      </div>
                      <div class="edit-zona__buttons edit-zona__buttons--right">
                        <button
                          type="button"
                          @click="
                            borrarItem({
                              borrador: true,
                              name: 'youtubeMedia',
                              index,
                            })
                          "
                          class="
                            edit-zona__btn
                            edit-zona__btn--warning
                            edit-zona__btn--consejos
                          "
                        >
                          Eliminar
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <!-- Gestion de informacion importante | input que se mostrara si se desea agregar un item en 'Incluye'-->
              <div class="edit-zona__input-group" v-if="addYoutubeMedia">
                <label class="edit-zona__label">Item</label>
                <input
                  v-model="youtubeMedia"
                  type="text"
                  class="edit-zona__input"
                />
              </div>
              <!--  -->
              <button
                v-if="!addYoutubeMedia"
                type="button"
                name="youtubeMedia"
                @click="addItem"
                class="edit-experiencia__btn edit-experiencia__btn--primary"
              >
                Registrar nuevo item
              </button>
              <button
                v-else
                type="button"
                name="youtubeMedia"
                @click="addItem"
                class="edit-experiencia__btn edit-experiencia__btn--success"
              >
                Agregar
              </button>
            </div>

            <!--  -->
          </div>
        </div>
      </div>
      <div
        class="edit-experiencia__informacion edit-experiencia__informacion--2"
      >
        <h3 class="heading heading--3 heading--center">Experiencia</h3>

        <div class="edit-experiencia__container">
          <div class="edit-experiencia__destacado">
            <I18nField
              label="Destacados"
              type="array-strings"
              placeholder="Agregar destacado"
              :value-es="experiencia.destacado"
              :value-en="experiencia.ingles.destacado"
              :value-pt="experiencia.portugues && experiencia.portugues.destacado"
              :manual-override="experiencia.manualOverride && experiencia.manualOverride.destacado"
              @add-item="(lang, item) => onI18nAddItem('destacado', lang, item)"
              @remove-item="(lang, index) => onI18nRemoveItem('destacado', lang, index)"
            />
            <!-- Gestion de destacados, lista borrador (pendiente de guardar) -->
            <div
              v-if="(experienciaBorrador.destacado && experienciaBorrador.destacado.length > 0)
                || (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.destacado && experiencia.ingles.experienciaBorrador.destacado.length > 0)
                || (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.destacado && experiencia.portugues.experienciaBorrador.destacado.length > 0)"
            >
              <h4 class="heading heading--4 heading--center">
                Destacados por agregar
              </h4>

              <div
                class="edit-zona__input-group"
                v-for="(destacado, index) in experienciaBorrador.destacado"
                :key="`destacado-borrador-es-${index}`"
              >
                <label class="edit-experiencia__label"
                  >ES — Destacado Nro {{ index + 1 }}</label
                >
                <textarea
                  class="edit-zona__textarea"
                  name="destacado"
                  cols="30"
                  rows="3"
                  :value="destacado"
                  disabled
                ></textarea>
                <div class="edit-zona__buttons edit-zona__buttons--right">
                  <button
                    class="edit-zona__btn edit-zona__btn--warning"
                    type="button"
                    @click="borrarItem({ borrador: true, name: 'destacado', index, language: 'es' })"
                  >
                    Eliminar
                  </button>
                </div>
              </div>

              <div
                class="edit-zona__input-group"
                v-for="(destacado, index) in (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.destacado) || []"
                :key="`destacado-borrador-en-${index}`"
              >
                <label class="edit-experiencia__label"
                  >EN — Destacado Nro {{ index + 1 }}</label
                >
                <textarea
                  class="edit-zona__textarea"
                  name="destacado"
                  cols="30"
                  rows="3"
                  :value="destacado"
                  disabled
                ></textarea>
                <div class="edit-zona__buttons edit-zona__buttons--right">
                  <button
                    class="edit-zona__btn edit-zona__btn--warning"
                    type="button"
                    @click="borrarItem({ borrador: true, name: 'destacado', index, language: 'en' })"
                  >
                    Eliminar
                  </button>
                </div>
              </div>

              <div
                class="edit-zona__input-group"
                v-for="(destacado, index) in (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.destacado) || []"
                :key="`destacado-borrador-pt-${index}`"
              >
                <label class="edit-experiencia__label"
                  >PT — Destacado Nro {{ index + 1 }}</label
                >
                <textarea
                  class="edit-zona__textarea"
                  name="destacado"
                  cols="30"
                  rows="3"
                  :value="destacado"
                  disabled
                ></textarea>
                <div class="edit-zona__buttons edit-zona__buttons--right">
                  <button
                    class="edit-zona__btn edit-zona__btn--warning"
                    type="button"
                    @click="borrarItem({ borrador: true, name: 'destacado', index, language: 'pt' })"
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Fin de destacado -->
        </div>
      </div>

      <div
        class="edit-experiencia__informacion edit-experiencia__informacion--5"
      >
        <h3 class="heading heading--3 heading--center">Disponibilidades</h3>

        <div class="edit-experiencia__container">
          <div class="edit-experiencia__disponibilidad">
            <div
              class="
                edit-experiencia__container edit-experiencia__container--flex
              "
            >
              <div class="edit-experiencia__side edit-experiencia__side--left">
                <!-- Gestion de disponibilidades | Cantidad de dias -->
                <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label"
                    >Cantidad de dias</label
                  >
                  <input
                    class="edit-zona__input"
                    type="number"
                    name="cantidadDias"
                    :value="experiencia.cantidadDias"
                    :disabled="experiencia.modalidad === 'fechaExclusiva'"
                    @change="handleChange"
                  />
                </div>

                <!-- Gestion de disponibilidades | Dias de anticipacion -->
                <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label"
                    >Dias de anticipacion</label
                  >
                  <input
                    class="edit-zona__input"
                    type="number"
                    name="diasAnticipacion"
                    :value="experiencia.diasAnticipacion"
                    @change="handleChange"
                  />
                </div>

                <!-- Gestion de disponibilidades | Seleccionar el modo de registro de disponibilidades -->
                <div class="edit-zona__input-group">
                  <label class="edit-zona__label">Registro de horas</label>
                  <select
                    :value="experiencia.modalidadHoras"
                    class="edit-experiencia__select"
                    name="modalidadHoras"
                    @change="handleChange"
                  >
                    <option value="unica">Hora de inicio unica</option>
                    <option value="multiple">Multiples horas de inicio</option>
                  </select>
                </div>

                <!-- Gestion de disponibilidades | Hora de inicio -->
                <template v-if="experiencia.modalidadHoras === 'unica'">
                  <div class="edit-experiencia__horas-unicas">
                    <div class="edit-zona__hora-registro" style="width: 45%">
                      <label class="edit-experiencia__label"
                        >Hora de inicio</label
                      >
                      <input
                        class="edit-zona__input"
                        type="time"
                        name="horaInicio"
                        :value="experiencia.horaInicio"
                        @change="handleChange"
                      />
                    </div>

                    <div class="edit-zona__hora-registro" style="width: 45%">
                      <label class="edit-experiencia__label">Hora de fin</label>
                      <input
                        class="edit-zona__input"
                        type="time"
                        name="horaFin"
                        :value="experiencia.horaFin"
                        @change="handleChange"
                      />
                    </div>
                  </div>
                </template>

                <!-- Gestion de disponibilidades | Multiples horas de inicio -->
                <template v-if="experiencia.modalidadHoras === 'multiple'">
                  <template
                    v-if="
                      experiencia.rangosHoras &&
                      experiencia.rangosHoras.length > 0
                    "
                  >
                    <h5>Horas almacenadas</h5>
                    <div
                      v-for="(hora, index) in experiencia.rangosHoras"
                      :key="index"
                    >
                      <div class="edit-experiencia__horas-unicas">
                        <div
                          class="edit-experiencia__hora-registro"
                          style="width: 45%"
                        >
                          <label class="edit-experiencia__label"
                            >Hora de inicio</label
                          >
                          <input
                            class="edit-zona__input"
                            type="time"
                            name="rangosHoras"
                            :value="hora.start"
                            disabled
                            @change="handleChange"
                          />
                        </div>

                        <div
                          class="edit-experiencia__hora-registro"
                          style="width: 45%"
                        >
                          <label class="edit-experiencia__label"
                            >Hora de fin</label
                          >
                          <input
                            class="edit-zona__input"
                            type="time"
                            name="rangosHoras"
                            :value="hora.end"
                            disabled
                            @change="handleChange"
                          />
                        </div>
                      </div>

                      <button
                        type="button"
                        class="edit-zona__btn edit-zona__btn--warning"
                        @click="
                          borrarItem({
                            borrador: false,
                            name: 'rangosHoras',
                            index,
                          })
                        "
                      >
                        Eliminar
                      </button>
                    </div>
                  </template>

                  <template
                    v-if="
                      experiencia.experienciaBorrador.rangosHoras &&
                      experiencia.experienciaBorrador.rangosHoras.length > 0
                    "
                  >
                    <!-- Horas de inicio | Horas en borrador -->
                    <h5>Horas por almacenar</h5>
                    <div
                      v-for="(hora, index) in experiencia.experienciaBorrador
                        .rangosHoras"
                      :key="`borrador` + index"
                    >
                      <div class="edit-experiencia__horas-unicas">
                        <div class="edit-zona__hora-registro">
                          <label class="edit-experiencia__label"
                            >Hora de inicio</label
                          >
                          <input
                            class="edit-zona__input"
                            type="time"
                            name="rangosHoras"
                            :value="hora.start"
                            disabled
                            @change="handleChange"
                          />
                        </div>
                        <div class="edit-zona__hora-registro">
                          <label class="edit-experiencia__label"
                            >Hora de fin</label
                          >
                          <input
                            class="edit-zona__input"
                            type="time"
                            name="rangosHoras"
                            :value="hora.end"
                            disabled
                            @change="handleChange"
                          />
                        </div>
                      </div>
                      <button
                        type="button"
                        class="edit-zona__btn edit-zona__btn--warning"
                        @click="
                          borrarItem({
                            borrador: true,
                            name: 'rangosHoras',
                            index,
                          })
                        "
                      >
                        Eliminar
                      </button>
                    </div>
                  </template>

                  <!-- Horas de inicio | introducir nuevas horas -->
                  <div class="edit-experiencia__horas-unicas">
                    <div
                      class="edit-experiencia__hora-registro"
                      style="width: 45%"
                    >
                      <label class="edit-experiencia__label"
                        >Hora de inicio</label
                      >
                      <input
                        class="edit-zona__input"
                        type="time"
                        name="rangosHoras"
                        v-model="rangoHorasItem.start"
                      />
                    </div>
                    <div
                      class="edit-experiencia__hora-registro"
                      style="width: 45%"
                    >
                      <label class="edit-experiencia__label">Hora de fin</label>
                      <input
                        class="edit-zona__input"
                        type="time"
                        name="rangosHoras"
                        v-model="rangoHorasItem.end"
                      />
                    </div>
                  </div>

                  <button
                    type="button"
                    class="edit-zona__btn edit-zona__btn--primary"
                    name="rangosHoras"
                    @click="addItem"
                  >
                    Agregar hora
                  </button>
                </template>

                <!-- Gestion de disponibilidades | Cantidad de horas -->
                <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label"
                    >Cantidad de horas</label
                  >
                  <input
                    class="edit-zona__input"
                    type="text"
                    :value="duracion"
                    :disabled="experiencia.cantidadDias > 1"
                    @change="handleChange"
                  />
                  <p class="paragraph" v-if="!(experiencia.cantidadDias > 1)">
                    Si la cantidad es cero la experiencia tendra una duracion de
                    24 horas
                  </p>
                </div>

                <!-- Gestion de disponibilidades | Seleccionar el modo de registro de disponibilidades -->
                <div class="edit-zona__input-group">
                  <label>Modalidad de la experiencia:</label>
                  <select
                    :value="experiencia.modalidadViaje"
                    class="edit-experiencia__select"
                    name="modalidadViaje"
                    @change="handleChange"
                  >
                    <option disabled value>Seleccione un elemento</option>
                    <option value="individual">Individual</option>
                    <option value="small">Grupo pequeno</option>
                    <option value="medium">Grupo mediano</option>
                    <option value="big">Grupo grande</option>
                  </select>
                </div>

                <!-- Gestion de disponibilidades | Seleccionar el modo de registro de disponibilidades -->
                <div class="edit-zona__input-group">
                  <label>Gestionar disponibilidad por:</label>
                  <select
                    :value="experiencia.modalidad"
                    class="edit-experiencia__select"
                    name="modalidad"
                    @change="handleChange"
                  >
                    <option disabled value>Seleccione un elemento</option>
                    <option value="fechaExclusiva">Fecha Exclusiva</option>
                    <option value="rangos">Rangos de fechas</option>
                    <option value="rangosTemporada">Rangos de temporada</option>
                    <option value="diasSemana">Dias de semana</option>
                  </select>
                </div>

                <div class="edit-zona__registro-dias">
                  <!-- Gestion de disponinilidades | Opcion de varios rangos -->
                  <div
                    v-if="
                      experiencia.modalidad === 'rangos' ||
                      experiencia.modalidad === 'rangosTemporada' ||
                      experiencia.modalidad === 'diasSemana'
                    "
                    class="
                      edit-experiencia__section
                      edit-experiencia__section--rangos
                    "
                  >
                    <div
                      class="edit-zona__container--fluid"
                      v-if="experiencia.disponibilidades.length > 0"
                    >
                      <label class="edit-zona__label"
                        >Disponibilidades almacenadas</label
                      >

                      <div
                        class="edit-experiencia__card"
                        v-for="(disponibilidadItem, index) in disponibilidades"
                        :key="index"
                      >
                        <label>Fechas</label>
                        <ul
                          class="
                            edit-experiencia__list edit-experiencia__list--1
                          "
                        >
                          <li class="edit-experiencia__list-item" type="button">
                            Desde:
                            {{ disponibilidadItem.start | toReadableDate }}
                          </li>
                          <li class="edit-experiencia__list-item" type="button">
                            Hasta :
                            {{ disponibilidadItem.end | toReadableDate }}
                          </li>
                        </ul>

                        <button
                          class="
                            edit-experiencia__btn edit-experiencia__btn--warning
                          "
                          type="button"
                          @click="
                            borrarItem({
                              borrador: false,
                              name: 'disponibilidades',
                              index,
                            })
                          "
                        >
                          Eliminar disponibilidad
                        </button>
                      </div>
                    </div>

                    <!-- Gestion de disponibilidades | Fechas de disponibilidad almacenadas en borrador -->
                    <div
                      class="edit-zona__container--fluid"
                      v-if="disponibilidadesBorrador.length > 0"
                    >
                      <label class="edit-zona__label"
                        >Disponibilidades a agregar</label
                      >
                      <div
                        class="edit-experiencia__card"
                        v-for="(
                          disponibilidadItem, index
                        ) in disponibilidadesBorrador"
                        :key="index"
                      >
                        <div
                          class="edit-zona__container--fluid"
                          v-if="disponibilidadItem"
                        >
                          <label class="edit-experiencia__label"
                            >Disponibilidad {{ index + 1 }}</label
                          >
                          <ul
                            class="
                              edit-experiencia__list edit-experiencia__list--1
                            "
                          >
                            <li class="edit-experiencia__list-item">
                              Desde:
                              {{ disponibilidadItem.start | toReadableDate }}
                            </li>
                          </ul>
                          <ul
                            class="
                              edit-experiencia__list edit-experiencia__list--1
                            "
                          >
                            <li class="edit-experiencia__list-item">
                              Hasta:
                              {{ disponibilidadItem.end | toReadableDate }}
                            </li>
                          </ul>
                        </div>
                        <button
                          class="
                            edit-experiencia__btn edit-experiencia__btn--warning
                          "
                          type="button"
                          @click="
                            borrarItem({
                              borrador: true,
                              name: 'disponibilidades',
                              index,
                            })
                          "
                        >
                          Eliminar disponibilidad
                        </button>
                      </div>
                    </div>

                    <div class="edit-experiencia__disponibilidades">
                      <div class="edit-zona__container--fluid">
                        <label class="edit-experiencia__label"
                          >Fechas a agregar</label
                        >
                        <ul
                          class="
                            edit-experiencia__list edit-experiencia__list--1
                          "
                        >
                          <li
                            v-if="!range || !range.start || !range.end"
                            class="edit-experiencia__list-item"
                          >
                            <p class="edit-experiencia__paragraph">
                              No hay fecha registrada
                            </p>
                          </li>
                          <li
                            v-if="range && range.start && range.end"
                            class="edit-experiencia__list-item"
                            type="button"
                          >
                            Desde: {{ range.start | toReadableDate }}
                          </li>
                          <li
                            v-if="range && range.start && range.end"
                            class="edit-experiencia__list-item"
                            type="button"
                          >
                            Hasta: {{ range.end | toReadableDate }}
                          </li>
                        </ul>
                      </div>

                      <div class="edit-zona__input-group">
                        <label class="edit-experiencia__label">Fecha</label>
                        <vc-date-picker
                          mode="range"
                          :value="range"
                          :min-date="new Date()"
                          is-inline
                          is-range
                          @input="handleDate"
                        ></vc-date-picker>
                      </div>
                      <button
                        class="
                          edit-experiencia__btn edit-experiencia__btn--primary
                        "
                        name="disponibilidades"
                        type="button"
                        style="width: 100%"
                        :disabled="!range || !range.start || !range.end"
                        @click="addItem"
                      >
                        Guardar disponibilidad
                      </button>
                    </div>
                  </div>

                  <!-- Gestion de disponibilidades | inputs checkbox para dias soportados -->
                  <div
                    v-if="experiencia.modalidad === 'diasSemana'"
                    class="edit-zona__input-group"
                  >
                    <h5 class="heading heading--5">
                      Dias de semana disponibles
                    </h5>
                    <ul class="edit-experiencia__idioma-options">
                      <li class="idioma-option">
                        <input
                          type="checkbox"
                          class="edit-experiencia__checkbox"
                          :value="1"
                          v-model="diasSemana"
                        />Lunes
                      </li>

                      <li class="idioma-option">
                        <input
                          type="checkbox"
                          class="edit-experiencia__checkbox"
                          :value="2"
                          v-model="diasSemana"
                        />Martes
                      </li>

                      <li class="idioma-option">
                        <input
                          type="checkbox"
                          class="edit-experiencia__checkbox"
                          :value="3"
                          v-model="diasSemana"
                        />Miercoles
                      </li>

                      <li class="idioma-option">
                        <input
                          type="checkbox"
                          class="edit-experiencia__checkbox"
                          :value="4"
                          v-model="diasSemana"
                        />Jueves
                      </li>

                      <li class="idioma-option">
                        <input
                          type="checkbox"
                          class="edit-experiencia__checkbox"
                          :value="5"
                          v-model="diasSemana"
                        />Viernes
                      </li>

                      <li class="idioma-option">
                        <input
                          type="checkbox"
                          class="edit-experiencia__checkbox"
                          :value="6"
                          v-model="diasSemana"
                        />Sabado
                      </li>
                      <li class="idioma-option">
                        <input
                          type="checkbox"
                          class="edit-experiencia__checkbox"
                          :value="0"
                          v-model="diasSemana"
                        />Domingo
                      </li>
                    </ul>
                  </div>

                  <!-- Gestion de disponibilidades | Modalidad Fecha Exclusiva -->
                  <div
                    v-if="experiencia.modalidad === 'fechaExclusiva'"
                    class="edit-zona__input-group edit-zona__fecha-exclusiva"
                  >
                    <h3 class="heading heading--3">Fecha Exclusiva</h3>
                    <!-- Gestion de disponibilidades | gestionador de fechas -->
                    <div class="edit-zona__input-group">
                      <input
                        name="fechaExclusiva"
                        :value="experiencia.fechaExclusiva"
                        type="datetime-local"
                        @change="handleChange"
                      />
                    </div>
                    <div
                      v-if="experiencia.fechaExclusiva"
                      class="edit-zona__input-group"
                    >
                      <h5>{{ experiencia.fechaExclusiva | toReadableDate }}</h5>
                      <button type="button" @click="resetFechaExclusiva">
                        Eliminar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label"
                    >Url para google maps</label
                  >
                  <input
                    class="edit-zona__input"
                    type="text"
                    name="googleMapsUrl"
                    :value="experiencia.googleMapsUrl"
                    @input="handleChange"
                  />
                </div>
              </div>
              <div class="edit-experiencia__side edit-experiencia__side--right">
                <!-- Gestion de disponibilidades | input para Stock -->
                <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label">Prioridad de experiencia destacadas</label>
                  <input
                    class="edit-zona__input"
                    type="number"
                    name="stock"
                    id="titulo"
                    :value="experiencia.stock"
                    @change="handleChange"
                  />
                </div>
                <!-- Gestion de disponibilidades | input para cantidad de visitas -->
                <!-- <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label">Visitas</label>
                  <input
                    class="edit-zona__input"
                    type="number"
                    name="visitas"
                    id="subtitulo"
                    :value="experiencia.visitas"
                    @change="handleChange"
                  />
                </div> -->
                <!-- Gestion de disponibilidades | input para puntaje -->
                <!-- <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label">Puntaje</label>
                  <input
                    class="edit-zona__input"
                    type="number"
                    name="puntaje"
                    :value="experiencia.puntaje"
                    @change="handleChange"
                  />
                </div> -->

                <!-- Gestion de disponibilidades | input para capacidad -->
                <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label"
                    >Capacidad minima de viajeros</label
                  >
                  <input
                    class="edit-zona__input"
                    type="number"
                    name="capacidadMinima"
                    :value="experiencia.capacidadMinima"
                    @change="handleChange"
                  />
                </div>
                <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label"
                    >Capacidad maxima de viajeros</label
                  >
                  <input
                    class="edit-zona__input"
                    type="number"
                    name="capacidad"
                    :value="experiencia.capacidad"
                    @change="handleChange"
                  />
                </div>
                <!-- Gestion de disponibilidades | inputs checkbox para idiomas soportados -->
                <div class="edit-zona__input-group">
                  <h5 class="heading heading--5">Idiomas disponibles</h5>
                  <ul class="edit-experiencia__idioma-options">
                    <li class="idioma-option">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="Inglés"
                        v-model="idiomas"
                      />Inglés
                    </li>
                    <li class="idioma-option oferta" v-if="experiencia.oferta">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="InglésOferta"
                        v-model="idiomas"
                      />Inglés Oferta
                    </li>
                    <li class="idioma-option">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="Español"
                        v-model="idiomas"
                      />Español
                    </li>
                    <li class="idioma-option oferta" v-if="experiencia.oferta">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="EspañolOferta"
                        v-model="idiomas"
                      />Español Oferta
                    </li>
                    <li class="idioma-option">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="Alemán"
                        v-model="idiomas"
                      />Alemán
                    </li>
                    <li class="idioma-option oferta" v-if="experiencia.oferta">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="AlemánOferta"
                        v-model="idiomas"
                      />Alemán Oferta
                    </li>
                    <li class="idioma-option">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="Francés"
                        v-model="idiomas"
                      />Francés
                    </li>
                    <li class="idioma-option oferta" v-if="experiencia.oferta">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="FrancésOferta"
                        v-model="idiomas"
                      />Francés Oferta
                    </li>
                    <li class="idioma-option">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="Portugués"
                        v-model="idiomas"
                      />Portugués
                    </li>
                    <li class="idioma-option oferta" v-if="experiencia.oferta">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="PortuguésOferta"
                        v-model="idiomas"
                      />Portugués Oferta
                    </li>
                    <li class="idioma-option">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="Mapudungún"
                        v-model="idiomas"
                      />Mapudungún
                    </li>
                    <li class="idioma-option oferta" v-if="experiencia.oferta">
                      <input
                        type="checkbox"
                        class="edit-experiencia__checkbox"
                        value="MapudungúnOferta"
                        v-model="idiomas"
                      />Mapudungún Oferta
                    </li>
                  </ul>
                </div>
                <!-- Checkbox para Tipo de Reserva -->
                <div class="edit-zona__input-group">
                  <label class="edit-experiencia__label"
                    >¿Reserva Inmediata?</label
                  >
                  <input
                    type="checkbox"
                    class="edit-experiencia__checkbox my-2"
                    value="true"
                    v-model="reservaInmediata"
                  />
                  <p>
                    <em
                      >Si esta casilla está desmarcada, por defecto la
                      experiencia será de tipo Reserva Tardía o Por
                      Confirmar</em
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Calendario set temporadas -->
      <div>
        <h3 class="heading heading--3 heading--center">Temporadas</h3>
        <CalendarioTemporadas :experienciaID="$route.params.id" />
      </div>

      <div>
        <!-- Ajuste de precios -->
        <h3 class="heading heading--3 heading--center mt-3">
          Ajuste de precios
        </h3>

        <div class="edit-zona__input-group container">
                <label class="edit-experiencia__label" for="oferta"
                  >¿Está en oferta?</label
                >
                <select
                  :value="experiencia.oferta"
                  @change="handleChange"
                  name="oferta"
                  class="form-control"
                >
                  <option :value="true">Si</option>
                  <option value="">No</option>
                </select>
        </div>

        <b-tabs
          class="tabs-temporadas container"
          content-class="tab-temporada"
          align="center"
          fill
        >
          <b-tab title="Precio fijo">
            <div class="edit-experiencia__side edit-experiencia__side--right">
              <div class="edit-zona__input-group">
                <label class="edit-experiencia__label">Precio base</label>
                <input
                  class="edit-zona__input"
                  :value="experiencia.precio"
                  type="number"
                  name="precio"
                  @input="handleChange"
                />

                <div
                  v-for="precioTemporada in experiencia.precioFijoTemporadas"
                  :key="`PrecioFijoTemporada${precioTemporada.temporada}`"
                  class="mt-2"
                >
                  <h5>Temporada {{precioTemporada.temporada}}</h5>
                  <input
                    class="edit-zona__input"
                    :value="precioTemporada.precio"
                    type="number"
                    :name="`precioFijoTemporadas${precioTemporada.temporada}`"
                    @input="handleChange"
                  />
                </div>
              </div>

              <!-- Oferta precio fijo -->
              
              <div
                v-if="experiencia.oferta"
                class="edit-zona__input-group"
              >
                <label class="edit-experiencia__label">Precio Oferta</label>
                <input
                  class="edit-zona__input"
                  :value="experiencia.precioOferta"
                  type="number"
                  name="precioOferta"
                  @input="handleChange"
                />
              </div>
            </div>
          </b-tab>
          <b-tab title="Precio según pasajeros">
            <!-- //pRECIOS CONFIG -->
            <template
              v-if="
                experiencia.preciosConfig &&
                experiencia.preciosConfig.length > 0
              "
            >
              <h5 class="container">Filas almacenadas</h5>
              <div
                v-for="(precioConfig, index) in experiencia.preciosConfig"
                :key="index"
                class="container edit-experiencia__precios-config"
              >
                <ul class="edit-experiencia__list edit-experiencia__list--flex">
                  <li
                    v-for="(propiedad, index) in sortedPropertiesPrecioConfig(
                      precioConfig
                    )"
                    :key="index"
                    class="
                      edit-experiencia__list-item edit-experiencia__list-item--1
                    "
                  >
                    <div
                      class="edit-experiencia__top edit-experiencia__top--list"
                    >
                      <p class="paragraph">{{ toReadable(propiedad) }}:</p>
                    </div>
                    <p class="paragraph">
                      {{
                        propiedad !== "cantidadPersonas"
                          ? `${precioConfig[propiedad]} CLP`
                          : `${precioConfig[propiedad]}`
                      }}
                    </p>
                  </li>
                </ul>
                <div class="edit-zona__buttons edit-zona__buttons--right">
                  <button
                    type="button"
                    class="edit-zona__btn edit-zona__btn--warning"
                    @click="
                      borrarItem({
                        borrador: false,
                        name: 'preciosConfig',
                        index,
                      })
                    "
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </template>

            <template
              v-if="
                experiencia.experienciaBorrador.preciosConfig &&
                experiencia.experienciaBorrador.preciosConfig.length > 0
              "
            >
              <h5>Filas por almacenar</h5>
              <div
                v-for="(precioConfig, index) in experiencia.experienciaBorrador
                  .preciosConfig"
                :key="index"
                class="edit-experiencia__precios-config"
              >
                <ul
                  class="
                    edit-experiencia__list
                    edit-experiencia__list--flex
                    edit-experiencia__list--overflow
                  "
                >
                  <li
                    v-for="(propiedad, index) in sortedPropertiesPrecioConfig(
                      precioConfig
                    )"
                    :key="index"
                    class="
                      edit-experiencia__list-item edit-experiencia__list-item--1
                    "
                  >
                    <div
                      class="edit-experiencia__top edit-experiencia__top--list"
                    >
                      <p class="paragraph">{{ toReadable(propiedad) }}:</p>
                    </div>
                    <p class="paragraph">
                      {{
                        propiedad !== "cantidadPersonas"
                          ? `${precioConfig[propiedad]} CLP`
                          : `${precioConfig[propiedad]}`
                      }}
                    </p>
                  </li>
                </ul>
                <div class="edit-zona__buttons edit-zona__buttons--right">
                  <button
                    type="button"
                    class="edit-zona__btn edit-zona__btn--warning"
                    @click="
                      borrarItem({
                        borrador: true,
                        name: 'preciosConfig',
                        index,
                      })
                    "
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </template>

            <template v-if="addPrecioConfig">
              <h5 class="container">Nueva fila</h5>
              <div class="container">
                <ul
                  class="
                    m-auto
                    edit-experiencia__list
                    edit-experiencia__list--flex
                    edit-experiencia__list--overflow
                  "
                  :style="{maxWidth: '100%' , overflowX: 'scroll' }"
                >
                  <li
                    class="
                      edit-experiencia__list-item edit-experiencia__list-item--1
                    "
                  >
                    <div
                      class="edit-experiencia__top edit-experiencia__top--list"
                    >
                      <p class="paragraph">Numero de pasajeros:</p>
                    </div>
                    <input
                      v-model="precioConfig.cantidadPersonas"
                      type="number"
                      class="edit-experiencia__input"
                      placeholder="Ingrese numero de pasajeros"
                    />
                  </li>
                  <template
                    v-if="getIdiomasInputs && getIdiomasInputs.length > 0"
                  >
                    <li
                      v-for="(idioma, index) in getIdiomasInputs"
                      :key="index"
                      class="
                        edit-experiencia__list-item edit-experiencia__list-item--1
                      "
                    >
                      <div
                        class="edit-experiencia__top edit-experiencia__top--list"
                      >
                        <p class="paragraph">Con idioma {{ idioma }}:</p>
                      </div>
                      <p class="mb-0 ">Temporada normal</p>
                      <input
                        v-model="precioConfig[idioma]"
                        type="number"
                        class="edit-experiencia__input"
                        placeholder="Ingrese precio"
                      />
                      <div 
                      v-for="(temporada, index) in experiencia.temporadas.temporadas"
                      :key="`${temporada}${index}`"
                      >
                      <p class="mb-0 mt-2">Precio temporada {{temporada.nombre}}</p>
                      <input
                        
                        v-model="precioConfig[`${idioma}_${temporada.nombre}`]"
                        type="number"
                        class="edit-experiencia__input"
                        :placeholder="`Temporada ${temporada.nombre}`"
                      />
                
                      </div>
                    </li>
                  </template>
                </ul>
              </div>
            </template>
            <div class="buttons container">
              <button
                v-if="!addPrecioConfig"
                @click="addItem"
                name="preciosConfig"
                type="button"
                class="edit-zona__btn edit-zona__btn--primary"
              >
                Agregar fila
              </button>
              <button
                v-else
                @click="addItem"
                name="preciosConfig"
                type="button"
                class="edit-zona__btn edit-zona__btn--success"
              >
                Agregar
              </button>
            </div>
          </b-tab>

          <b-tab title="Precio niñ@s">
            <!-- PRECIO NIÑ@S -->
            <div class="container mx-auto edit-experiencia__container">
              <div class="d-flex justify-content-center">
                <template>
                  <label class="edit-experiencia__label" for="oferta"
                    >¿Precio diferenciado por edad?</label
                  >
                  <select
                    :value="experiencia.precioDiferenciadoNiños"
                    @change="handleChange"
                    name="precioDiferenciadoNiños"
                    class="w-25"
                  >
                    <option :value="true">Si</option>
                    <option value="">No</option>
                  </select>
                </template>
              </div>

              <div v-if="experiencia.precioDiferenciadoNiños">
                <template
                  v-if="
                    experiencia.precioDiferenciadoNiños &&
                    experiencia.precioNiños.length > 0
                  "
                >
                  <h5 class="container">Filas almacenadas</h5>
                  <div
                    v-for="(precioNiño, index) in experiencia.precioNiños"
                    :key="index"
                    class="container edit-experiencia__precios-config"
                  >
                    <ul
                      class="
                        edit-experiencia__list edit-experiencia__list--flex
                      "
                    >
                      <li
                        v-for="(propiedad, index) in sortedPropertiesPrecioNiño(
                          precioNiño
                        )"
                        :key="index"
                        class="
                          edit-experiencia__list-item
                          edit-experiencia__list-item--1
                        "
                      >
                        <div
                          class="
                            edit-experiencia__top edit-experiencia__top--list
                          "
                        >
                          <p class="paragraph">{{ propiedad }}:</p>
                        </div>
                        <p class="paragraph">
                          {{
                            propiedad == "precio"
                              ? `${precioNiño[propiedad]} CLP`
                              : `${precioNiño[propiedad]}`
                          }}
                        </p>
                      </li>
                    </ul>
                    <div class="edit-zona__buttons edit-zona__buttons--right">
                      <button
                        type="button"
                        class="edit-zona__btn edit-zona__btn--warning"
                        @click="
                          borrarItem({
                            borrador: false,
                            name: 'precioNiños',
                            index,
                          })
                        "
                      >
                        Eliminar
                      </button>
                    </div>
                  </div>
                </template>

                <template
                  v-if="
                    experiencia.experienciaBorrador.precioNiños &&
                    experiencia.experienciaBorrador.precioNiños.length > 0
                  "
                >
                  <h5>Filas por almacenar</h5>
                  <div
                    v-for="(precioNiño, index) in experiencia
                      .experienciaBorrador.precioNiños"
                    :key="index"
                    class="edit-experiencia__precios-config"
                  >
                    <ul
                      class="
                        edit-experiencia__list
                        edit-experiencia__list--flex
                        edit-experiencia__list--overflow
                      "
                    >
                      <li
                        v-for="(propiedad, index) in sortedPropertiesPrecioNiño(
                          precioNiño
                        )"
                        :key="index"
                        class="
                          edit-experiencia__list-item
                          edit-experiencia__list-item--1
                        "
                      >
                        <div
                          class="
                            edit-experiencia__top edit-experiencia__top--list
                          "
                        >
                          <p class="paragraph">{{ propiedad }}:</p>
                        </div>
                        <p class="paragraph">
                          {{
                            propiedad == "precio"
                              ? `${precioNiño[propiedad]} CLP`
                              : `${precioNiño[propiedad]}`
                          }}
                        </p>
                      </li>
                    </ul>
                    <div class="edit-zona__buttons edit-zona__buttons--right">
                      <button
                        type="button"
                        class="edit-zona__btn edit-zona__btn--warning"
                        @click="
                          borrarItem({
                            borrador: true,
                            name: 'precioNiños',
                            index,
                          })
                        "
                      >
                        Eliminar
                      </button>
                    </div>
                  </div>
                </template>

                <template v-if="addPrecioNiño">
                  <h5 class="container">Nueva fila</h5>
                  <ul
                    class="
                      container
                      m-auto
                      edit-experiencia__list
                      edit-experiencia__list--flex
                      edit-experiencia__list--overflow
                    "
                  >
                    <li
                      class="
                        edit-experiencia__list-item
                        edit-experiencia__list-item--1
                      "
                    >
                      <div
                        class="
                          edit-experiencia__top edit-experiencia__top--list
                        "
                      >
                        <p class="paragraph">Nombre:</p>
                      </div>
                      <input
                        v-model="precioNiño.nombre"
                        type="text"
                        class="edit-experiencia__input"
                        placeholder="Ej: (infante, niño)"
                      />
                    </li>
                    <li
                      class="
                        edit-experiencia__list-item
                        edit-experiencia__list-item--1
                      "
                    >
                      <div
                        class="
                          edit-experiencia__top edit-experiencia__top--list
                        "
                      >
                        <p class="paragraph">Edad mínima:</p>
                      </div>
                      <input
                        v-model="precioNiño.edadMinima"
                        type="number"
                        class="edit-experiencia__input"
                        placeholder="Edad mínima"
                      />
                    </li>
                    <li
                      class="
                        edit-experiencia__list-item
                        edit-experiencia__list-item--1
                      "
                    >
                      <div
                        class="
                          edit-experiencia__top edit-experiencia__top--list
                        "
                      >
                        <p class="paragraph">Edad máxima:</p>
                      </div>
                      <input
                        v-model="precioNiño.edadMaxima"
                        type="number"
                        class="edit-experiencia__input"
                        placeholder="Edad máxima"
                      />
                    </li>
                    <li
                      class="
                        edit-experiencia__list-item
                        edit-experiencia__list-item--1
                      "
                    >
                      <div
                        class="
                          edit-experiencia__top edit-experiencia__top--list
                        "
                      >
                        <p class="paragraph">Precio:</p>
                      </div>
                      <input
                        v-model="precioNiño.precio"
                        type="number"
                        class="edit-experiencia__input"
                        placeholder="Precio"
                      />
                    </li>
                  </ul>
                </template>
                <div class="buttons container">
                  <button
                    v-if="!addPrecioNiño"
                    @click="addItem"
                    name="precioNiños"
                    type="button"
                    class="edit-zona__btn edit-zona__btn--primary"
                  >
                    Agregar fila
                  </button>
                  <button
                    v-else
                    @click="addItem"
                    name="precioNiños"
                    type="button"
                    class="edit-zona__btn edit-zona__btn--success"
                  >
                    Agregar
                  </button>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <!-- ¿ Permite abono ? -->
      <div class="container mt-4">
        <h3 class="text-center">Abono</h3>
        <div class="edit-zona__input-group">
          <label class="edit-experiencia__label" for="oferta"
            >¿Permite abono?</label
          >
          <select
            :value="experiencia.permiteAbono"
            @change="handleChange"
            name="permiteAbono"
            class="form-control"
          >
            <option :value="true">Si</option>
            <option value="">No</option>
          </select>
        </div>
        <div
          v-if="experiencia.permiteAbono"
          class="edit-zona__input-group"
        >
          <label class="edit-experiencia__label">Porcentaje de abono</label>
          <input
            class="edit-zona__input"
            :value="experiencia.porcentajeAbono"
            type="number"
            name="porcentajeAbono"
            @input="handleChange"
          />
          <span>%</span>
        </div>
        <!-- Dias de anticipacion del 2do pago: hasta cuantos dias ANTES del
             viaje se puede pagar el saldo. Si la reserva se solicita a <= N
             dias del viaje, el sitio cobra el 100% en un solo pago. -->
        <div
          v-if="experiencia.permiteAbono"
          class="edit-zona__input-group"
        >
          <label class="edit-experiencia__label">Días para el segundo pago</label>
          <input
            class="edit-zona__input"
            :value="experiencia.diasSegundoPago"
            type="number"
            min="0"
            name="diasSegundoPago"
            @input="handleChange"
          />
          <span>días antes del viaje (si falta menos, se cobra el 100%)</span>
        </div>
      </div>

      <!--MENSAJE PERSONALIZADO + PRECIO MAS BAJO MANUAL  -->
      <div class="container mt-4">
        <h3 class="text-center">Precio más bajo </h3>

        <div
          class="edit-zona__input-group"
        >
          <label class="edit-experiencia__label">Precio más bajo</label>
          <h6>Si no vas a usar este campo no olvides dejarlo en blanco.</h6>
          <input
            class="edit-zona__input mb-2"
            :value="experiencia.precioMasBajo"
            type="number"
            name="precioMasBajo"
            @input="handleChange"
          />

          <I18nField
            label="Mensaje precio bajo"
            type="textarea"
            :value-es="experiencia.mensajePrecioMasBajo"
            :value-en="experiencia.ingles.mensajePrecioMasBajo"
            :value-pt="experiencia.portugues && experiencia.portugues.mensajePrecioMasBajo"
            :manual-override="experiencia.manualOverride && experiencia.manualOverride.mensajePrecioMasBajo"
            @change="(lang, val) => onI18nFieldChange('mensajePrecioMasBajo', lang, val, 'text')"
          />
        </div>
      </div>

      <!--
        Brief Rediseno Destinos (2026-05-17) §6 — Precio para 1 persona.
        Resuelve la frustracion del solo traveler que ve "X / persona" en
        la card del destino basado en 2 pax y descubre que paga distinto.
        Si esta vacio, el sitio publico cae al fallback estimado
        (perPax * 1.7) con flag visual ambar.
      -->
      <div class="container mt-4">
        <h3 class="text-center">Precio para 1 persona (single)</h3>
        <div class="edit-zona__input-group">
          <label class="edit-experiencia__label">Valor exacto (CLP)</label>
          <h6>
            Dejar vacío si todavía no tienes el precio definitivo.
            Si vacío, el sitio muestra una estimación con aviso.
          </h6>
          <input
            class="edit-zona__input mb-2"
            :value="experiencia.precioSolo"
            type="number"
            name="precioSolo"
            min="0"
            placeholder="Ej: 330000"
            @input="handleChange"
          />
        </div>
      </div>

      <!--
        Brief Rediseno Destinos (2026-05-17) §6 — Etiquetas contextuales.
        Pills que aparecen en las cards de destino. Pablo solo las activa
        cuando el operador del lodge confirmo. Default conservador: ambas
        en false hasta confirmacion explicita.
      -->
      <div class="container mt-4">
        <h3 class="text-center">Etiquetas contextuales</h3>
        <div class="edit-zona__input-group">
          <h6 class="text-center mb-3">
            Estas etiquetas aparecen como pills en las cards de destino.
            Solo actívalas cuando el lodge confirme.
          </h6>
          <div class="edit-zona__input-group">
            <b-form-checkbox
              :checked="!!experiencia.aptoNinos"
              @change="(val) => onContextBadgeChange('aptoNinos', val)"
            >
              Apto para niños — admite menores de 12 años
            </b-form-checkbox>
          </div>
          <div class="edit-zona__input-group">
            <b-form-checkbox
              :checked="!!experiencia.petFriendly"
              @change="(val) => onContextBadgeChange('petFriendly', val)"
            >
              Pet friendly — admite mascotas
            </b-form-checkbox>
          </div>
        </div>
      </div>


      <!--  -->
      <div
        class="edit-experiencia__informacion edit-experiencia__informacion--3"
      >
        <h3 class="heading heading--3 heading--center">Itinerario</h3>

        <div class="edit-experiencia__container">
          <div class="edit-experiencia__itinerario">
            <!-- Gestion de itinerario, input para el resumen -->
            <div class="edit-zona__input-group">
              <I18nField
                label="Resumen de itinerario"
                type="textarea"
                :rows="10"
                :value-es="experiencia.descripcion.resumen"
                :value-en="experiencia.ingles.descripcion.resumen"
                :value-pt="experiencia.portugues && experiencia.portugues.descripcion && experiencia.portugues.descripcion.resumen"
                :manual-override="experiencia.manualOverride && experiencia.manualOverride['descripcion.resumen']"
                @change="(lang, val) => onI18nFieldChange('descripcion.resumen', lang, val, 'text')"
              />
            </div>

            <I18nField
              v-if="experiencia.cantidadDias > 1"
              label="Dias del itinerario"
              type="array-html"
              placeholder="Agregar dia"
              :value-es="experiencia.descripcion.dias"
              :value-en="experiencia.ingles.descripcion.dias"
              :value-pt="experiencia.portugues && experiencia.portugues.descripcion && experiencia.portugues.descripcion.dias"
              :manual-override="experiencia.manualOverride && experiencia.manualOverride['descripcion.dias']"
              @add-item="(lang, item) => onI18nAddItem('dias', lang, item)"
              @remove-item="(lang, index) => onI18nRemoveItem('descripcion.dias', lang, index)"
            />
            <!-- Gestion de itinerario | dias en borrador (pendientes de guardar) -->
            <div
              v-if="experiencia.cantidadDias > 1 && (
                (experienciaBorrador.dias && experienciaBorrador.dias.length > 0)
                || (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.dias && experiencia.ingles.experienciaBorrador.dias.length > 0)
                || (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.dias && experiencia.portugues.experienciaBorrador.dias.length > 0)
              )"
              class="edit-experiencia__dias"
            >
              <h4 class="heading heading--4 heading--center">
                Dias a registrarse (borrador)
              </h4>
              <div
                class="edit-zona__input-group"
                v-for="(dia, index) in experienciaBorrador.dias"
                :key="`dia-borrador-es-${index}`"
              >
                <label class="edit-experiencia__label">ES — Dia {{ index + 1 }}</label>
                <textarea
                  class="edit-zona__textarea"
                  cols="30"
                  rows="6"
                  :value="dia"
                  disabled
                ></textarea>
                <div class="edit-zona__buttons edit-zona__buttons--right">
                  <button
                    class="edit-zona__btn edit-zona__btn--warning"
                    type="button"
                    @click="borrarItem({ borrador: true, name: 'dias', index, language: 'es' })"
                  >
                    Eliminar dia
                  </button>
                </div>
              </div>
              <div
                class="edit-zona__input-group"
                v-for="(dia, index) in (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.dias) || []"
                :key="`dia-borrador-en-${index}`"
              >
                <label class="edit-experiencia__label">EN — Dia {{ index + 1 }}</label>
                <textarea
                  class="edit-zona__textarea"
                  cols="30"
                  rows="6"
                  :value="dia"
                  disabled
                ></textarea>
                <div class="edit-zona__buttons edit-zona__buttons--right">
                  <button
                    class="edit-zona__btn edit-zona__btn--warning"
                    type="button"
                    @click="borrarItem({ borrador: true, name: 'dias', index, language: 'en' })"
                  >
                    Eliminar dia
                  </button>
                </div>
              </div>
              <div
                class="edit-zona__input-group"
                v-for="(dia, index) in (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.dias) || []"
                :key="`dia-borrador-pt-${index}`"
              >
                <label class="edit-experiencia__label">PT — Dia {{ index + 1 }}</label>
                <textarea
                  class="edit-zona__textarea"
                  cols="30"
                  rows="6"
                  :value="dia"
                  disabled
                ></textarea>
                <div class="edit-zona__buttons edit-zona__buttons--right">
                  <button
                    class="edit-zona__btn edit-zona__btn--warning"
                    type="button"
                    @click="borrarItem({ borrador: true, name: 'dias', index, language: 'pt' })"
                  >
                    Eliminar dia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="edit-experiencia__informacion edit-experiencia__informacion--4"
      >
        <h3 class="heading heading--3 heading--center">
          Informacion importante
        </h3>

        <div class="edit-experiencia__container">
          <div class="edit-experiencia__informacion-importante">
            <div class="edit-experiencia__reglas">
              <!-- Gestion de informacion importante, gestion de normas -->
              <div
                class="
                  edit-experiencia__informacion-importante
                  edit-experiencia__informacion-importante--1
                "
              >
                <h4 class="heading heading--5">Incluye:</h4>
                <I18nField
                  label="Incluye"
                  type="array-strings"
                  placeholder="Agregar item"
                  :value-es="experiencia.informacionImportante.incluye"
                  :value-en="experiencia.ingles.informacionImportante.incluye"
                  :value-pt="experiencia.portugues && experiencia.portugues.informacionImportante && experiencia.portugues.informacionImportante.incluye"
                  :manual-override="experiencia.manualOverride && experiencia.manualOverride['informacionImportante.incluye']"
                  @add-item="(lang, item) => onI18nAddItem('informacionImportante.incluye', lang, item)"
                  @remove-item="(lang, index) => onI18nRemoveItem('informacionImportante.incluye', lang, index)"
                />

                <!-- Gestion de informacion importante | items 'Incluye' borrador (pendientes de guardar) -->
                <div
                  class="edit-zona__container--fluid"
                  v-if="(experienciaBorrador.informacionImportante && experienciaBorrador.informacionImportante.incluye && experienciaBorrador.informacionImportante.incluye.length > 0)
                    || (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.informacionImportante && experiencia.ingles.experienciaBorrador.informacionImportante.incluye && experiencia.ingles.experienciaBorrador.informacionImportante.incluye.length > 0)
                    || (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.informacionImportante && experiencia.portugues.experienciaBorrador.informacionImportante.incluye && experiencia.portugues.experienciaBorrador.informacionImportante.incluye.length > 0)"
                >
                  <label class="edit-experiencia__label">Items por agregar (borrador)</label>
                  <ul class="edit-zona__list edit-zona__list--1">
                    <li class="edit-zona__list-item" v-for="(item, index) in (experienciaBorrador.informacionImportante && experienciaBorrador.informacionImportante.incluye) || []" :key="`incluye-borrador-es-${index}`">
                      <div class="edit-zona__list-content">
                        <p class="paragraph">ES — {{ item }}</p>
                        <div class="edit-zona__buttons edit-zona__buttons--right">
                          <button type="button" @click="borrarItem({ level: 'informacionImportante', borrador: true, name: 'incluye', index, language: 'es' })" class="edit-zona__btn edit-zona__btn--warning edit-zona__btn--consejos">
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </li>
                    <li class="edit-zona__list-item" v-for="(item, index) in (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.informacionImportante && experiencia.ingles.experienciaBorrador.informacionImportante.incluye) || []" :key="`incluye-borrador-en-${index}`">
                      <div class="edit-zona__list-content">
                        <p class="paragraph">EN — {{ item }}</p>
                        <div class="edit-zona__buttons edit-zona__buttons--right">
                          <button type="button" @click="borrarItem({ level: 'informacionImportante', borrador: true, name: 'incluye', index, language: 'en' })" class="edit-zona__btn edit-zona__btn--warning edit-zona__btn--consejos">
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </li>
                    <li class="edit-zona__list-item" v-for="(item, index) in (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.informacionImportante && experiencia.portugues.experienciaBorrador.informacionImportante.incluye) || []" :key="`incluye-borrador-pt-${index}`">
                      <div class="edit-zona__list-content">
                        <p class="paragraph">PT — {{ item }}</p>
                        <div class="edit-zona__buttons edit-zona__buttons--right">
                          <button type="button" @click="borrarItem({ level: 'informacionImportante', borrador: true, name: 'incluye', index, language: 'pt' })" class="edit-zona__btn edit-zona__btn--warning edit-zona__btn--consejos">
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <!--  -->

              <div
                class="
                  edit-experiencia__informacion-importante
                  edit-experiencia__informacion-importante--2
                "
              >
                <h4 class="heading heading--3">No incluye:</h4>
                <I18nField
                  label="No incluye"
                  type="array-strings"
                  placeholder="Agregar item"
                  :value-es="experiencia.informacionImportante.noIncluye"
                  :value-en="experiencia.ingles.informacionImportante.noIncluye"
                  :value-pt="experiencia.portugues && experiencia.portugues.informacionImportante && experiencia.portugues.informacionImportante.noIncluye"
                  :manual-override="experiencia.manualOverride && experiencia.manualOverride['informacionImportante.noIncluye']"
                  @add-item="(lang, item) => onI18nAddItem('informacionImportante.noIncluye', lang, item)"
                  @remove-item="(lang, index) => onI18nRemoveItem('informacionImportante.noIncluye', lang, index)"
                />
                <!-- Gestion de informacion importante | items "no incluye" borrador (pendientes de guardar) -->
                <div
                  class="edit-zona__container--fluid"
                  v-if="(experiencia.experienciaBorrador.informacionImportante && experiencia.experienciaBorrador.informacionImportante.noIncluye && experiencia.experienciaBorrador.informacionImportante.noIncluye.length > 0)
                    || (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.informacionImportante && experiencia.ingles.experienciaBorrador.informacionImportante.noIncluye && experiencia.ingles.experienciaBorrador.informacionImportante.noIncluye.length > 0)
                    || (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.informacionImportante && experiencia.portugues.experienciaBorrador.informacionImportante.noIncluye && experiencia.portugues.experienciaBorrador.informacionImportante.noIncluye.length > 0)"
                >
                  <label class="edit-experiencia__label">Items por agregar (borrador)</label>
                  <ul class="edit-zona__list edit-zona__list--1">
                    <li class="edit-zona__list-item" v-for="(item, index) in (experiencia.experienciaBorrador.informacionImportante && experiencia.experienciaBorrador.informacionImportante.noIncluye) || []" :key="`noIncluye-borrador-es-${index}`">
                      <div class="edit-zona__list-content">
                        <p class="paragraph">ES — {{ item }}</p>
                        <div class="edit-zona__buttons edit-zona__buttons--right">
                          <button type="button" @click="borrarItem({ level: 'informacionImportante', borrador: true, name: 'noIncluye', index, language: 'es' })" class="edit-zona__btn edit-zona__btn--warning edit-zona__btn--consejos">
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </li>
                    <li class="edit-zona__list-item" v-for="(item, index) in (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.informacionImportante && experiencia.ingles.experienciaBorrador.informacionImportante.noIncluye) || []" :key="`noIncluye-borrador-en-${index}`">
                      <div class="edit-zona__list-content">
                        <p class="paragraph">EN — {{ item }}</p>
                        <div class="edit-zona__buttons edit-zona__buttons--right">
                          <button type="button" @click="borrarItem({ level: 'informacionImportante', borrador: true, name: 'noIncluye', index, language: 'en' })" class="edit-zona__btn edit-zona__btn--warning edit-zona__btn--consejos">
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </li>
                    <li class="edit-zona__list-item" v-for="(item, index) in (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.informacionImportante && experiencia.portugues.experienciaBorrador.informacionImportante.noIncluye) || []" :key="`noIncluye-borrador-pt-${index}`">
                      <div class="edit-zona__list-content">
                        <p class="paragraph">PT — {{ item }}</p>
                        <div class="edit-zona__buttons edit-zona__buttons--right">
                          <button type="button" @click="borrarItem({ level: 'informacionImportante', borrador: true, name: 'noIncluye', index, language: 'pt' })" class="edit-zona__btn edit-zona__btn--warning edit-zona__btn--consejos">
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="edit-experiencia__reglas">
              <div
                class="
                  edit-experiencia__informacion-importante
                  edit-experiencia__informacion-importante--3
                "
              >
                <h4 class="heading heading--4">Debes traer:</h4>
                <I18nField
                  label="Debes traer"
                  type="array-strings"
                  placeholder="Agregar item"
                  :value-es="experiencia.informacionImportante.debesTraer"
                  :value-en="experiencia.ingles.informacionImportante.debesTraer"
                  :value-pt="experiencia.portugues && experiencia.portugues.informacionImportante && experiencia.portugues.informacionImportante.debesTraer"
                  :manual-override="experiencia.manualOverride && experiencia.manualOverride['informacionImportante.debesTraer']"
                  @add-item="(lang, item) => onI18nAddItem('informacionImportante.debesTraer', lang, item)"
                  @remove-item="(lang, index) => onI18nRemoveItem('informacionImportante.debesTraer', lang, index)"
                />
                <!-- Gestion de informacion importante | items "debes traer" borrador (pendientes de guardar) -->
                <div
                  class="edit-zona__container--fluid"
                  v-if="(experiencia.experienciaBorrador.informacionImportante && experiencia.experienciaBorrador.informacionImportante.debesTraer && experiencia.experienciaBorrador.informacionImportante.debesTraer.length > 0)
                    || (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.informacionImportante && experiencia.ingles.experienciaBorrador.informacionImportante.debesTraer && experiencia.ingles.experienciaBorrador.informacionImportante.debesTraer.length > 0)
                    || (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.informacionImportante && experiencia.portugues.experienciaBorrador.informacionImportante.debesTraer && experiencia.portugues.experienciaBorrador.informacionImportante.debesTraer.length > 0)"
                >
                  <label class="edit-experiencia__label">Items por agregar (borrador)</label>
                  <ul class="edit-zona__list edit-zona__list--1">
                    <li class="edit-zona__list-item" v-for="(item, index) in (experiencia.experienciaBorrador.informacionImportante && experiencia.experienciaBorrador.informacionImportante.debesTraer) || []" :key="`debesTraer-borrador-es-${index}`">
                      <div class="edit-zona__list-content">
                        <p class="paragraph">ES — {{ item }}</p>
                        <div class="edit-zona__buttons edit-zona__buttons--right">
                          <button type="button" @click="borrarItem({ level: 'informacionImportante', borrador: true, name: 'debesTraer', index, language: 'es' })" class="edit-zona__btn edit-zona__btn--warning edit-zona__btn--consejos">
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </li>
                    <li class="edit-zona__list-item" v-for="(item, index) in (experiencia.ingles.experienciaBorrador && experiencia.ingles.experienciaBorrador.informacionImportante && experiencia.ingles.experienciaBorrador.informacionImportante.debesTraer) || []" :key="`debesTraer-borrador-en-${index}`">
                      <div class="edit-zona__list-content">
                        <p class="paragraph">EN — {{ item }}</p>
                        <div class="edit-zona__buttons edit-zona__buttons--right">
                          <button type="button" @click="borrarItem({ level: 'informacionImportante', borrador: true, name: 'debesTraer', index, language: 'en' })" class="edit-zona__btn edit-zona__btn--warning edit-zona__btn--consejos">
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </li>
                    <li class="edit-zona__list-item" v-for="(item, index) in (experiencia.portugues && experiencia.portugues.experienciaBorrador && experiencia.portugues.experienciaBorrador.informacionImportante && experiencia.portugues.experienciaBorrador.informacionImportante.debesTraer) || []" :key="`debesTraer-borrador-pt-${index}`">
                      <div class="edit-zona__list-content">
                        <p class="paragraph">PT — {{ item }}</p>
                        <div class="edit-zona__buttons edit-zona__buttons--right">
                          <button type="button" @click="borrarItem({ level: 'informacionImportante', borrador: true, name: 'debesTraer', index, language: 'pt' })" class="edit-zona__btn edit-zona__btn--warning edit-zona__btn--consejos">
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Gestion de informacion importante | input para resumen -->
              <div class="edit-experiencia__informacion-importante--4">
                <I18nField
                  label="Resumen de informacion importante"
                  type="textarea"
                  :rows="10"
                  :value-es="experiencia.informacionImportante.resumen"
                  :value-en="experiencia.ingles.informacionImportante.resumen"
                  :value-pt="experiencia.portugues && experiencia.portugues.informacionImportante && experiencia.portugues.informacionImportante.resumen"
                  :manual-override="experiencia.manualOverride && experiencia.manualOverride['informacionImportante.resumen']"
                  @change="(lang, val) => onI18nFieldChange('informacionImportante.resumen', lang, val, 'text')"
                />
              </div>

              <!-- Como llegar (rich text editor) -->
              <div class="edit-experiencia__informacion-importante--4">
                <I18nField
                  label="Cómo llegar"
                  type="quill"
                  :quill-toolbar="comoLlegarToolbar"
                  :value-es="experiencia.informacionImportante.comoLlegar"
                  :value-en="experiencia.ingles && experiencia.ingles.informacionImportante && experiencia.ingles.informacionImportante.comoLlegar"
                  :value-pt="experiencia.portugues && experiencia.portugues.informacionImportante && experiencia.portugues.informacionImportante.comoLlegar"
                  :manual-override="experiencia.manualOverride && experiencia.manualOverride['informacionImportante.comoLlegar']"
                  @change="(lang, val) => onI18nFieldChange('informacionImportante.comoLlegar', lang, val, 'text')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-zona__buttons">
        <div class="edit-zona__loading-button">
          <button
            class="edit-experiencia__btn edit-experiencia__btn--primary"
            :disabled="isLoading"
          >
            Guardar
          </button>
          <div v-if="isLoading" class="lds-dual-ring"></div>
        </div>
        <button
          @click="cancelExperiencia"
          class="edit-experiencia__btn edit-experiencia__btn--secondary"
          style="margin: 50px"
          type="button"
          :disabled="isLoading"
        >
          Cancelar
        </button>
      </div>
    </form>
  
    <!-- Paquetes de regalo (botonRegalos en Firestore) -->
    <div class="container my-5 py-4 px-4" style="background-color: rgba(255,255,255,0.05); border-radius: 8px;">
      <h2 class="text-white mb-3">Paquetes de regalo</h2>
      <p class="text-white-50 mb-4">
        Define los precios de esta experiencia cuando se compra como regalo (con fecha abierta).
        Puedes agregar varios paquetes (ej. uno por temporada), cada uno con su propia validez.
      </p>
      <div v-for="(paquete, index) in (experiencia.botonRegalos || [])" :key="index" class="mb-3 p-3" style="background-color: rgba(255,255,255,0.1); border-radius: 6px;">
        <div class="row">
          <div class="col-md-6 mb-2">
            <label class="text-white">Descripcion / Validez</label>
            <input type="text" class="form-control" v-model="paquete.description" placeholder="Ej: Para ir hasta el 30 de diciembre de 2026 (2 personas)" />
          </div>
          <div class="col-md-4 mb-2">
            <label class="text-white">Precio (CLP)</label>
            <input type="number" class="form-control" v-model.number="paquete.price" placeholder="218000" />
          </div>
          <div class="col-md-2 mb-2 d-flex align-items-end">
            <button type="button" class="btn btn-danger btn-block" @click="removePaqueteRegalo(index)">
              Eliminar
            </button>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-success" @click="addPaqueteRegalo">
        + Agregar paquete
      </button>
    </div>

    <!-- Servicios opcionales (opcionales en Firestore) -->
    <!-- Tres tipos de cobro: por_persona (precio x N), global (precio unico), -->
    <!-- escalonado (precio por persona que varia segun tramos de cantidad). -->
    <div class="container my-5 py-4 px-4" style="background-color: rgba(255,255,255,0.05); border-radius: 8px;">
      <h2 class="text-white mb-3">Servicios adicionales</h2>
      <p class="text-white-50 mb-4">
        Servicios que el pasajero puede agregar al reservar (ej: alimentacion full board, masajes, uso de tinaja, trekking guiado). Cada adicional tiene un tipo de cobro: por persona, precio unico (global), o escalonado (precio por persona que cambia segun cuanta gente va). Los pasajeros marcan cuales agregar antes de pagar.
      </p>
      <div v-for="(op, index) in (experiencia.opcionales || [])" :key="op.id || index" class="mb-3 p-3" style="background-color: rgba(255,255,255,0.1); border-radius: 6px;">
        <div class="row">
          <div class="col-md-5 mb-2">
            <label class="text-white">Nombre del servicio</label>
            <input type="text" class="form-control" v-model="op.nombre" placeholder="Ej: Alimentacion full board" />
          </div>
          <div class="col-md-3 mb-2">
            <label class="text-white">Tipo de cobro</label>
            <select class="form-control" v-model="op.tipoCobro">
              <option value="por_persona">Por persona (precio x cantidad)</option>
              <option value="global">Precio unico (no depende de cantidad)</option>
              <option value="escalonado">Escalonado (precio por persona segun cantidad)</option>
            </select>
          </div>
          <div class="col-md-2 mb-2 d-flex align-items-end">
            <b-form-checkbox v-model="op.activo" class="text-white">Activo</b-form-checkbox>
          </div>
          <div class="col-md-2 mb-2 d-flex align-items-end">
            <button type="button" class="btn btn-danger btn-block" @click="removeOpcional(index)">
              Eliminar
            </button>
          </div>
        </div>
        <!-- Precio simple: para tipo por_persona y global -->
        <div class="row" v-if="op.tipoCobro !== 'escalonado'">
          <div class="col-md-4 mb-2">
            <label class="text-white">
              {{ op.tipoCobro === 'global' ? 'Precio CLP (unico, todo el grupo)' : 'Precio CLP (por persona)' }}
            </label>
            <input type="number" class="form-control" v-model.number="op.precio" min="0" step="1000" placeholder="25000" />
          </div>
        </div>
        <!-- Tramos: para tipo escalonado -->
        <div v-else class="mt-2">
          <label class="text-white">Tramos de precio (precio por persona segun cantidad)</label>
          <p class="text-white-50 mb-2" style="font-size: 13px;">
            Cada tramo aplica "desde N personas". Ej: "desde 1 = $100.000" y "desde 2 = $60.000" significa $100.000 si va 1 persona, $60.000 c/u si van 2 o mas. Ordena de menor a mayor.
          </p>
          <div v-for="(tramo, ti) in (op.tramos || [])" :key="ti" class="row mb-2 align-items-end">
            <div class="col-md-3">
              <label class="text-white" style="font-size: 13px;">Desde (cant. personas)</label>
              <input type="number" class="form-control" v-model.number="tramo.desde" min="1" step="1" placeholder="1" />
            </div>
            <div class="col-md-4">
              <label class="text-white" style="font-size: 13px;">Precio CLP por persona</label>
              <input type="number" class="form-control" v-model.number="tramo.precioPorPersona" min="0" step="1000" placeholder="60000" />
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-danger btn-block" @click="removeTramo(op, ti)">
                Quitar
              </button>
            </div>
          </div>
          <button type="button" class="btn btn-sm btn-outline-light" @click="addTramo(op)">
            + Agregar tramo
          </button>
        </div>
      </div>
      <button type="button" class="btn btn-success" @click="addOpcional">
        + Agregar adicional
      </button>
    </div></div>

  </template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import CalendarioTemporadas from "@/components/Admin/CalendarioTemporadas";
import EditorMediosGaleria from "@/components/Admin/EditorMediosGaleria";
import { VueEditor } from "vue2-editor";
import I18nField from "@/components/I18nField.vue";

import { db, storage } from "../../firebase.service";

export default {
  metaInfo: {
    title: "Editar experiencia",
  },
  data() {
    return {
      id: null,
      duplicandoVersion: false,
      versionesCaja: [],
      versionesCajaCargadas: false,
      mostrarVersionesCaja: false,
      trueBoolean: true,
      falseBoolean: false,
      destinoId: null,
      zonaId: null,
      addYoutubeMedia: false,
      youtubeMedia: null,
      addIncluyeItem: false,
      incluyeItem: null,
      addNoIncluyeItem: false,
      noIncluyeItem: null,
      addDebesTraerItem: false,
      debesTraerItem: null,
      addDestacado: false,
      destacado: null,
      addDia: false,
      dia: null,
      disponibilidad: [],
      fecha: null,
      addFecha: false,
      tipoGestion: "",
      range: null,
      lastRange: null,
      rangoHorasItem: {
        start: null,
        end: null,
      },
      pdescuento: null,
      addPrecioConfig: false,
      precioConfig: {
        cantidadPersonas: 0,
        temporadas: {},
      },
      precioNiño: {
        nombre: "",
        edadMinima: 0,
        edadMaxima: 0,
        precio: 0,
      },
      addPrecioNiño: false,
      ranguito: null,
      tag: "",
      comoLlegarToolbar: [
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["blockquote", "link"],
        ["clean"]
      ]
    };
  },
  components: { CalendarioTemporadas, EditorMediosGaleria, VueEditor, I18nField },
  created() {
    const { name, params } = this.$route;
    if (name === "RegistrarExperiencia") {
      this.resetExperiencia();
      this.zonaId = params.zonaId;
      this.destinoId = params.id;
      this.setZonaId(this.zonaId);
      this.setDestinoId(this.destinoId);
      this.setExperienciaId(null);
    } else if (name === "EditExperiencia") {
      this.zonaId = params.zonaId;
      this.destinoId = params.destinoId;
      this.id = params.id;
      this.setZonaId(this.zonaId);
      this.setDestinoId(this.destinoId);
      this.setExperienciaId(this.id);
    }
  },
  destroyed() {
    this.resetExperiencia();
  },
  watch: {
    "experiencia.idiomas"(value) {
      if (
        this.experiencia &&
        this.experiencia.idiomas &&
        this.experiencia.idiomas.length > 0
      ) {
        this.precioConfig = Object.assign(
          {},
          {
            cantidadPersonas: 0,
          }
        );
      }
    },
  },
  computed: {
    ...mapGetters([
      "experiencia",
      "zonaImgsToSave",
      "experienciaBorrador",
      "isLoading",
      "getExperiencias",
    ]),
    isOculto() {
      if (!this.id || !this.getExperiencias) return false;
      const exp = this.getExperiencias.find(e => e.id === this.id);
      return !!(exp && exp.oculto);
    },
    idiomas: {
      get() {
        // Algoritmo para actualizar los idiomas que fueron colocados sin tilde
        const idiomas = [
          "Inglés",
          "Español",
          "Alemán",
          "Francés",
          "Portugués",
          "Mapudungún",
        ];
        if (this.$store.state.experiencia.idiomas.length > 0) {
          const idiomasFilter = idiomas.filter((idioma) =>
            this.$store.state.experiencia.idiomas.includes(idioma)
          );
          if (!(idiomasFilter.length > 0)) {
            this.$store.commit("updateIdiomas", []);
          }
        }
        return this.$store.state.experiencia.idiomas;
      },
      set(value) {
        this.$store.commit("updateIdiomas", value);
      },
    },
    reservaInmediata: {
      get() {
        return this.$store.state.experiencia.reserva_inmediata;
      },
      set(value) {
        this.$store.commit("updateReservaInmediata", value);
      },
    },
    diasSemana: {
      get() {
        return this.$store.state.experiencia.disponibilidad;
      },
      set(value) {
        this.$store.commit("updateDiasSemana", value);
      },
    },
    disponibilidades: {
      get() {
        return this.$store.state.experiencia.disponibilidades;
      },
    },
    disponibilidadesBorrador: {
      get() {
        return this.$store.state.experiencia.experienciaBorrador
          .disponibilidades;
      },
    },
    getIdiomasInputs() {
      if (this.experiencia.idiomas && this.experiencia.idiomas.length > 0) {
        this.experiencia.idiomas.forEach((idioma) => {
          this.$set(this.precioConfig, idioma, 0);
        });
        return this.experiencia.idiomas;
      }
      return null;
    },
    getHeroContent() {
      if (this.experiencia && this.experiencia.heroImgUrls) {
        if (this.experiencia.heroImgUrls.length > 0) {
          const heroContentRef = this.experiencia.heroImgUrls.map(
            (contentUrl) => {
              const { name } = storage.refFromURL(contentUrl);
              const nameParts = name.split(".");
              return {
                type: nameParts[1],
                contentUrl,
              };
            }
          );
          return heroContentRef;
        }
      }
      return null;
    },
    getHeroContentBorrador() {
      if (
        this.zonaImgsToSave.heroImgUrls &&
        this.zonaImgsToSave.heroImgUrls.length > 0
      ) {
        const heroContentRef = this.zonaImgsToSave.heroImgUrls.map(
          (contentUrl) => {
            const extension = contentUrl
              .split(";")[0]
              .split(":")[1]
              .split("/")[0];
            return {
              type: extension,
              contentUrl,
            };
          }
        );
        return heroContentRef;
      }
      return null;
    },
    duracion() {
      if (
        !(
          (this.experiencia.horaInicio && this.experiencia.horaFin) ||
          (this.rangoHorasItem.start && this.rangoHorasItem.end)
        )
      ) {
        return "Registre hora de inicio y fin";
      }

      let start;
      let end;

      if (this.experiencia.horaInicio && this.experiencia.horaFin) {
        const { horaInicio, horaFin } = this.experiencia;
        start = horaInicio;
        end = horaFin;
      } else {
        start = this.rangoHorasItem.start;
        end = this.rangoHorasItem.end;
      }

      const startDate = new Date("01/01/2020 " + start + ":00");
      let endDate = new Date("01/01/2020 " + end + ":00");

      const startTime = startDate.getTime();
      let endTime = endDate.getTime();

      if (endTime - startTime < 0) {
        endDate = new Date("01/02/2020 " + end + ":00");
        endTime = endDate.getTime();
      }

      // Diferencia de tiempo en minutos
      const timeDifference = Math.abs(endTime - startTime) / (1000 * 60);
      const horasDifference = (timeDifference - (timeDifference % 60)) / 60;
      const minutosDifference = timeDifference % 60;

      // Variables con contenido textual
      const horas =
        horasDifference > 0
          ? horasDifference > 1
            ? `${horasDifference} Horas`
            : `${horasDifference} Hora`
          : "";
      const minutos =
        minutosDifference > 0
          ? minutosDifference > 1
            ? ` ${minutosDifference} Minutos`
            : ` ${minutosDifference} Minuto`
          : "";
      return horas + minutos;
    },
  },
  methods: {
    async toggleOcultoRequest() {
      if (!this.experiencia || !this.id) return;
      const newValue = !this.isOculto;
      const msg = newValue
        ? 'Ocultar esta experiencia del listado publico? (la URL directa seguira funcionando)'
        : 'Mostrar esta experiencia nuevamente en el listado publico?';
      if (!window.confirm(msg)) return;
      try {
        await db.collection('experiencias').doc(this.id).update({ oculto: newValue });
        alert(newValue ? 'Experiencia oculta del listado.' : 'Experiencia visible nuevamente.');
      } catch (e) {
        console.log('Error al alternar oculto:', e);
        alert('Hubo un error al cambiar el estado. Intenta de nuevo.');
      }
    },
    // Crea una VERSIÓN de caja (subcolección experiencias/{id}/versiones)
    // pre-poblada desde esta escapada padre, y navega a su editor. La versión
    // hereda fotos/descripción/reseñas del padre en el sitio público; aquí solo
    // se editan nombre, noches, incluye/no incluye, valor interno y cajas.
    async duplicarComoVersionCaja() {
      if (!this.id || !this.experiencia || this.duplicandoVersion) return;
      if (!window.confirm('Crear una versión de caja pre-poblada desde esta escapada? Luego editas nombre, noches, incluye y a qué cajas pertenece.')) return;
      this.duplicandoVersion = true;
      const e = this.experiencia;
      const info = e.informacionImportante || {};
      const infoEn = (e.ingles && e.ingles.informacionImportante) || {};
      const infoPt = (e.portugues && e.portugues.informacionImportante) || {};
      const noches = Math.max(0, (parseInt(e.cantidadDias, 10) || 1) - 1);
      const arr = (x) => (Array.isArray(x) ? x.slice() : []);
      const data = {
        padreId: this.id,
        padreSlug: e.slug || '',
        nombre: e.titulo || '',
        noches,
        itinerarioResumen: '',
        incluye: arr(info.incluye),
        noIncluye: arr(info.noIncluye),
        cajaSlugs: [],
        valorReferencia: 0,
        publicada: false,
        ingles: {
          nombre: (e.ingles && e.ingles.titulo) || '',
          incluye: arr(infoEn.incluye),
          noIncluye: arr(infoEn.noIncluye),
        },
        portugues: {
          nombre: (e.portugues && e.portugues.titulo) || '',
          incluye: arr(infoPt.incluye),
          noIncluye: arr(infoPt.noIncluye),
        },
        manualOverride: {},
        ts: Date.now(),
      };
      try {
        const ref = await db.collection('experiencias').doc(this.id).collection('versiones').add(data);
        this.$router.push({ name: 'EditVersionCaja', params: { padreId: this.id, vid: ref.id } });
      } catch (err) {
        alert('No se pudo crear la versión: ' + (err && err.message));
      } finally {
        this.duplicandoVersion = false;
      }
    },
    async toggleVersionesCaja() {
      this.mostrarVersionesCaja = !this.mostrarVersionesCaja;
      if (this.mostrarVersionesCaja && !this.versionesCajaCargadas && this.id) {
        try {
          const snap = await db.collection('experiencias').doc(this.id).collection('versiones').get();
          this.versionesCaja = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        } catch (e) {
          console.log('Error cargando versiones de caja:', e);
        } finally {
          this.versionesCajaCargadas = true;
        }
      }
    },
    editarVersionCaja(vid) {
      this.$router.push({ name: 'EditVersionCaja', params: { padreId: this.id, vid } });
    },
    addPaqueteRegalo() {
      if (!this.experiencia.botonRegalos) {
        this.$set(this.experiencia, 'botonRegalos', []);
      }
      this.experiencia.botonRegalos.push({ price: 0, description: '' });
    },
    removePaqueteRegalo(index) {
      if (!this.experiencia.botonRegalos) return;
      if (window.confirm('Eliminar este paquete de regalo?')) {
        this.experiencia.botonRegalos.splice(index, 1);
      }
    },
    addOpcional() {
      if (!this.experiencia.opcionales) {
        this.$set(this.experiencia, 'opcionales', []);
      }
      // crypto.randomUUID disponible en navegadores modernos; fallback timestamp+random
      // por si Pablo edita desde un browser que no lo soporta.
      const id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : Date.now() + '-' + Math.random().toString(36).slice(2, 10);
      // tipoCobro default 'por_persona' = comportamiento historico (precio x cantidad).
      // tramos solo se usa cuando tipoCobro === 'escalonado'.
      this.experiencia.opcionales.push({ id, nombre: '', precio: 0, activo: true, tipoCobro: 'por_persona', tramos: [] });
    },
    removeOpcional(index) {
      if (!this.experiencia.opcionales) return;
      if (window.confirm('Eliminar este servicio adicional?')) {
        this.experiencia.opcionales.splice(index, 1);
      }
    },
    addTramo(opcional) {
      // $set por si el opcional viejo no tenia el campo tramos (retrocompat).
      if (!Array.isArray(opcional.tramos)) {
        this.$set(opcional, 'tramos', []);
      }
      // Default: el primer tramo arranca en "desde 1", los siguientes en "desde 2".
      const desde = opcional.tramos.length === 0 ? 1 : 2;
      opcional.tramos.push({ desde, precioPorPersona: 0 });
    },
    removeTramo(opcional, tramoIndex) {
      if (!Array.isArray(opcional.tramos)) return;
      opcional.tramos.splice(tramoIndex, 1);
    },
    ...mapActions([
      "experienciaTypeChange",
      "addHeroImg",
      "submitExperiencia",
      "submitItem",
      "addImg",
      "deleteUnsavedImg",
      "deleteImg",
      "setZonaId",
      "setDestinoId",
      "setExperienciaId",
      "deleteExperiencia",
      "borrarItem",
    ]),
    ...mapMutations([
      "resetExperiencia",
      "resetFechaExclusiva",
      "switchLoading",
      "switchDelete",
    ]),
    onI18nFieldChange(name, lang, value, type = "text") {
      this.experienciaTypeChange({ type, name, value, language: lang });
    },
    onI18nAddItem(name, lang, item, level = null) {
      if (!level && name.includes(".")) {
        const [lvl, n] = name.split(".");
        this.submitItem({ level: lvl, name: n, value: item, language: lang });
        return;
      }
      this.submitItem({ level, name, value: item, language: lang });
    },
    onI18nRemoveItem(name, lang, index, level = null) {
      if (!level && name.includes(".")) {
        const [lvl, n] = name.split(".");
        this.borrarItem({ borrador: false, level: lvl, name: n, index, language: lang });
        return;
      }
      this.borrarItem({ borrador: false, name, index, language: lang, level });
    },
    sortedPropertiesPrecioConfig(precioConfig) {
      const sortedArray = ["cantidadPersonas"];
      const properties = Object.keys(precioConfig);
      const idiomas = properties.filter((property) => {
        return property !== "cantidadPersonas";
      });
      if (idiomas && idiomas.length > 0) {
        sortedArray.push(...idiomas);
        return sortedArray;
      }
      return null;
    },
    sortedPropertiesPrecioNiño(precioNiño) {
      const sortedArray = ["nombre"];
      const properties = Object.keys(precioNiño);
      const idiomas = properties.filter((property) => {
        return property !== "nombre";
      });
      if (idiomas && idiomas.length > 0) {
        sortedArray.push(...idiomas);
        return sortedArray;
      }
      return null;
    },
    toReadable(value) {
      if (value === "cantidadPersonas") {
        return "N° Personas";
      }
      if (value !== "cantidadPersonas") {
        return `${value}`;
      }
    },
    cancelExperiencia() {
      this.$router.push({
        path: "/admin",
      });
    },
    async submitRequest(value) {
      try {
        this.switchLoading(true);
        await this.submitExperiencia(value);
        this.switchLoading(false);
      } catch (error) {
        console.log("Error: ", error);
        this.switchLoading(false);
      }
    },
    async deleteRequest(value) {
      try {
        this.switchDelete(true);
        this.switchLoading(true);
        await this.deleteExperiencia(value);
        this.switchDelete(false);
        this.switchLoading(false);
      } catch (error) {
        this.switchDelete(false);
        this.switchLoading(false);
        console.log(error);
      }
    },
    handleDate(value) {
      const { start, end } = value;
      const min = new Date(start).getTime();
      let limit;
      let limitRange;
      if (this.experiencia.modalidad === "rangos") {
        const dias = this.experiencia.cantidadDias - 1;
        limit = min + dias * (1000 * 60 * 60 * 24);
        limitRange = {
          start,
          end: new Date(limit),
        };
      }
      if (
        this.experiencia.modalidad === "rangosTemporada" ||
        this.experiencia.modalidad === "diasSemana"
      ) {
        limitRange = {
          start,
          end,
        };
      }
      this.range = limitRange;
    },
    navigateFromExperiencia() {
      this.$router.push({
        path: `/admin/zonas/${this.zonaId}/destinos/${this.destinoId}`,
      });
    },
    handleChange(event) {
      const { name, value, type } = event.target;
      this.experienciaTypeChange({ type, name, value });
    },
    // Brief Rediseno Destinos (2026-05-17). aptoNinos / petFriendly son
    // booleans top-level. b-form-checkbox emite el valor nuevo via @change
    // (no via event.target.value), asi que no podemos reusar handleChange
    // directo. Forzamos Boolean para evitar guardar undefined/strings.
    onContextBadgeChange(name, val) {
      this.experienciaTypeChange({
        type: 'boolean',
        name,
        value: Boolean(val),
        language: 'es',
      });
    },
    // Handler del v-model emitido por <EditorMediosGaleria>. Recibe el array
    // entero de medios y lo persiste como un campo top-level del state.
    // Force language: 'es' porque la galeria mixta no tiene versiones en/pt
    // — es contenido visual compartido entre los 3 idiomas (los textos como
    // alt y titulo de cada item son contenido per-idioma a futuro, pero por
    // ahora se guardan en el item directo y se traducen en una fase posterior).
    onMediosChange(newMedios) {
      this.experienciaTypeChange({
        type: 'array',
        name: 'medios',
        value: newMedios,
        language: 'es',
      });
    },
    onComoLlegarInput(html) {
      this.experienciaTypeChange({ type: 'text', name: 'informacionImportante.comoLlegar', value: html });
    },
    addItem(event) {
      const { name } = event.target;
      console.log('entra aqui', event);
      switch (name) {
        case "youtubeMedia":
          if (name === "youtubeMedia" && this.addYoutubeMedia) {
            if (this.youtubeMedia && this.youtubeMedia.length > 0) {
              const youtubePattern =
                /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/gm;
              if (this.youtubeMedia.match(youtubePattern)) {
                const formattedLink = this.youtubeMedia.replace(
                  "watch?v=",
                  "embed/"
                );
                this.submitItem({
                  name,
                  value: formattedLink,
                });
                this.youtubeMedia = null;
                this.addYoutubeMedia = false;
              } else {
                alert("Ingrese un link de youtube valido");
              }
            }
            return;
          }
          this.addYoutubeMedia = true;
          break;
        case "incluye":
          if (name === "incluye" && this.addIncluyeItem) {
            if (this.incluyeItem && this.incluyeItem.length > 0) {
              this.submitItem({
                level: "informacionImportante",
                name,
                value: this.incluyeItem,
              });
              this.incluyeItem = null;
              this.addIncluyeItem = false;
            }
            return;
          }
          this.addIncluyeItem = true;
          break;
        case "noIncluye":
          if (name === "noIncluye" && this.addNoIncluyeItem) {
            if (this.noIncluyeItem && this.noIncluyeItem.length > 0) {
              this.submitItem({
                level: "informacionImportante",
                name,
                value: this.noIncluyeItem,
              });
              this.noIncluyeItem = null;
              this.addNoIncluyeItem = false;
            }
            return;
          }
          this.addNoIncluyeItem = true;
          break;
        case "debesTraer":
          if (name === "debesTraer" && this.addDebesTraerItem) {
            if (this.debesTraerItem && this.debesTraerItem.length > 0) {
              this.submitItem({
                level: "informacionImportante",
                name,
                value: this.debesTraerItem,
              });
              this.debesTraerItem = null;
              this.addDebesTraerItem = false;
            }
            return;
          }
          this.addDebesTraerItem = true;
          break;
        case "destacado":
          if (name === "destacado" && this.addDestacado) {
            if (this.destacado && this.destacado.length > 0) {
              this.submitItem({
                name,
                value: this.destacado,
              });
              this.destacado = null;
              this.addDestacado = false;
            }
            return;
          }
          this.addDestacado = true;
          break;
        case "dias":
          if (name === "dias" && this.addDia) {
            if (this.dia && this.dia.length > 0) {
              this.submitItem({
                name,
                value: this.dia,
              });
              this.dia = null;
              this.addDia = false;
            }
            return;
          }
          this.addDia = true;
          break;
        case "disponibilidades":
          if (name === "disponibilidades") {
            if (this.range) {
              this.submitItem({
                name,
                value: this.range,
              });
              this.range = {
                start: null,
                end: null,
              };
            }
          }
          break;
        case "fecha":
          if (this.addFecha) {
            if (this.fecha && this.fecha.length > 0) {
              this.disponibilidad.push(this.fecha);
              this.addFecha = false;
              this.fecha = null;
              return;
            }
          }
          this.addFecha = true;
          break;
        case "rangosHoras":
          if (
            this.rangoHorasItem &&
            this.rangoHorasItem.start &&
            this.rangoHorasItem.end
          ) {
            this.submitItem({
              name,
              value: this.rangoHorasItem,
            });
            this.rangoHorasItem = Object.assign(
              {},
              {
                start: null,
                end: null,
              }
            );
          }
          break;
        case "preciosConfig":
          if (this.addPrecioConfig) {
            this.submitItem({
              name,
              value: this.precioConfig,
            });
            this.precioConfig = Object.assign({}, this.precioConfig, {
              cantidadPersonas: 0,
            });
            this.addPrecioConfig = false;
            return;
          }
          this.addPrecioConfig = true;

          //Agregar variables segun idioma y temporada
          this.experiencia.idiomas.forEach(idioma => {
            this.precioConfig[idioma] = 0

            this.experiencia.temporadas.temporadas.forEach(temporada =>{
              this.precioConfig[`${idioma}_${temporada.nombre}`] = 0
            })
          })
          break;
        /* case "tags":
          console.log('entra en tag', this.tag);
          if (this.tag.length > 0) {
            this.submitItem({
              name,
              value: this.tag,
            });
            this.tag = "";
            this.addTag = false;
            return;
          }
          this.addTag = true;
          break; */
        case "precioNiños":
          if (this.addPrecioNiño) {
            this.submitItem({
              name,
              value: this.precioNiño,
            });
            this.precioNiño = Object.assign({}, this.precioNiño, {
              nombre: "",
              edadMinima: 0,
              edadMaxima: 0,
              precio: 0,
            });
            this.addPrecioNiño = false;
            return;
          }
          this.addPrecioNiño = true;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.oferta {
  color: #d43b32 !important;
  font-weight: 700;
}
.edit-experiencia {
  &__horas-unicas {
    display: flex;
    justify-content: space-between;
  }

  &__hora-registro {
    width: 40%;
    display: flex;
    flex-direction: column;
    padding: 20px 0;
    align-items: stretch;
  }

  color: white;

  &__disponibilidades {
    box-shadow: 1px 1px 3px black;
    background: white;
    padding: 20px;
    border-radius: 5px;

    label {
      color: black;
    }
  }

  &__input {
    padding: 10px;
    display: block;
    margin: auto;
  }

  &__reglas {
    display: flex;
    border-bottom: 1px solid white;
    justify-content: space-between;
    padding: 50px 0;
  }

  &__informacion-importante {
    &--1,
    &--2,
    &--3,
    &--4 {
      width: 45%;
    }

    &--4 {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__select {
    padding: 15px;
  }

  &__paragraph {
    margin: 0;
  }

  &__card {
    background: white;
    padding: 20px;
    color: black;
    border-radius: 5px;
    box-shadow: 1px 1px 3px;
    margin-bottom: 30px;
  }

  &__idioma-options {
    list-style-type: none;
  }

  &__precios-config {
    padding: 20px 0;
  }

  &__list {
    list-style-type: none;
    margin: 0;

    &--1 {
      padding-top: 20px;
    }

    &--flex {
      display: flex;
      background: white;
      border-radius: 3px;
      box-shadow: 1px 1px 5px black;
    }

    &--overflow {
      // overflow-x: scroll;  
    }
  }

  &__list-item {
    background: #fff;
    border-top: 1px solid grey;
    color: black;
    font-weight: 500;
    padding: 15px 0;

    &:last-child {
      border-bottom: 1px solid grey;
    }

    &--1 {
      text-align: center;
      border-top: none;
      border-right: 1px solid grey;
      flex: 1 1 0px;
      padding: 0;
      width: fit-content;
      &:last-child {
        border: none;
      }
    }
  }

  &__top {
    &--list {
      width: 100%;
      background: darkslategray;
      color: white;
      box-shadow: 1px 1px 3px black;
    }
  }

  &__container {
    width: 90%;
    margin: auto;
  }

  &__label {
    margin: 0;
    font-size: 1.3rem;
  }

  &__container--flex {
    display: flex;
    justify-content: space-between;
  }

  &__side {
    width: 45%;
  }

  &__informacion {
    padding: 50px 0;
  }

  &__buttons {
    text-align: center;
  }

  &__btn {
    border-radius: 5px;
    margin: 10px 0;
    padding: 10px;
    font-weight: 500;
    box-shadow: 1px 1px 3px black;
    border: none;

    &--warning {
      background: rgb(206, 64, 64);
      color: white;
    }

    &--success {
      color: white;
      background: rgb(12, 128, 12);
    }

    &--primary {
      color: white;
      background: rgb(55, 127, 221);
    }
  }

  &__img {
    height: 150px;
    width: 180px;
    margin: 10px;
    border-radius: 5px;
    box-shadow: 1px 1px 5px;

    &--1 {
      background: rgb(26, 26, 26);
    }
  }

  &__img-container {
    display: flex;
    flex-wrap: wrap;
  }

  &__destino {
    border: 1px solid black;
    display: inline-block;
  }

  &__checkbox {
    margin-right: 10px;
  }
}

.heading {
  &--center {
    text-align: center;
  }
}
</style>

<style lang="scss">
/* Montserrat font for VueEditor (Quill) - matches public site */
.ql-container,
.ql-editor {
  font-family: 'Montserrat', sans-serif !important;
}
.ql-editor {
  min-height: 180px;
  font-size: 1rem;
}
.tabs-temporadas {
  .tab-temporada,
  .tab-content {
    height: fit-content !important;
    border: 1px solid #fff !important;
    color: #fff !important;
  }
}
</style>
